import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  JSONString: any;
  UUID: any;
};

export type AnalyteHealthRange = {
  __typename?: 'AnalyteHealthRange';
  analyte: AnalyteHealthRangeAnalyte;
  healthProfile: HealthProfile;
  high: Scalars['Float'];
  low: Scalars['Float'];
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export enum AnalyteHealthRangeAnalyte {
  Aluminum = 'ALUMINUM',
  AmmoniumNitrogen = 'AMMONIUM_NITROGEN',
  Arsenic = 'ARSENIC',
  Boron = 'BORON',
  Cadmium = 'CADMIUM',
  Calcium = 'CALCIUM',
  CecEstimation = 'CEC_ESTIMATION',
  Copper = 'COPPER',
  Ec = 'EC',
  FusariumSpp = 'FUSARIUM_SPP',
  HopLatentViroid = 'HOP_LATENT_VIROID',
  Iron = 'IRON',
  Lead = 'LEAD',
  Magnesium = 'MAGNESIUM',
  Manganese = 'MANGANESE',
  Mercury = 'MERCURY',
  Molybdenum = 'MOLYBDENUM',
  NitrateNitrogen = 'NITRATE_NITROGEN',
  Nitrogen = 'NITROGEN',
  Ph = 'PH',
  Phosphorus = 'PHOSPHORUS',
  PhosphorusPentoxide = 'PHOSPHORUS_PENTOXIDE',
  Potassium = 'POTASSIUM',
  PotassiumOxide = 'POTASSIUM_OXIDE',
  PythiumSpp = 'PYTHIUM_SPP',
  Sar = 'SAR',
  Sodium = 'SODIUM',
  Sulfur = 'SULFUR',
  Tds = 'TDS',
  Zinc = 'ZINC'
}

export type AnalyteInfo = {
  __typename?: 'AnalyteInfo';
  group: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
  measurementUnit: Scalars['String'];
  nicknames: Array<Scalars['String']>;
};

export type ApplicationSettings = {
  __typename?: 'ApplicationSettings';
  analytes: Array<AnalyteInfo>;
  testAnalytes: Array<TestAnalytes>;
};

export type ArchiveHealthProfile = {
  __typename?: 'ArchiveHealthProfile';
  healthProfile?: Maybe<HealthProfile>;
};

export type ClientCompany = {
  __typename?: 'ClientCompany';
  addressCity: Scalars['String'];
  addressState: Scalars['String'];
  addressStreet: Scalars['String'];
  addressStreet2: Scalars['String'];
  addressZip: Scalars['String'];
  billingEmail: Scalars['String'];
  businessName: Scalars['String'];
  clientUsers: Array<User>;
  easypostAddressId: Scalars['String'];
  id: Scalars['UUID'];
  laboratory: Laboratory;
  paymentTerms: ClientCompanyPaymentTerms;
  phone: Scalars['String'];
  priceTestFertilizer?: Maybe<Scalars['Int']>;
  priceTestFusariumSpp?: Maybe<Scalars['Int']>;
  priceTestHeavyMetal?: Maybe<Scalars['Int']>;
  priceTestHopLatentViroid?: Maybe<Scalars['Int']>;
  priceTestNutrient?: Maybe<Scalars['Int']>;
  priceTestPlantTissue?: Maybe<Scalars['Int']>;
  priceTestPythiumSpp?: Maybe<Scalars['Int']>;
  priceTestRunOff?: Maybe<Scalars['Int']>;
  priceTestSoil?: Maybe<Scalars['Int']>;
  priceTestWater?: Maybe<Scalars['Int']>;
};

export enum ClientCompanyCultivationStyle {
  DoubleStack = 'DOUBLE_STACK',
  Greenhouse = 'GREENHOUSE',
  HoopHouse = 'HOOP_HOUSE',
  Indoor = 'INDOOR',
  LightDeprivation = 'LIGHT_DEPRIVATION',
  Outdoor = 'OUTDOOR',
  SingleStack = 'SINGLE_STACK',
  SupplementalLight = 'SUPPLEMENTAL_LIGHT',
  TripleStack = 'TRIPLE_STACK'
}

export type ClientCompanyFilterSetInput = {
  billingEmail_Icontains?: InputMaybe<Scalars['String']>;
  businessName_Icontains?: InputMaybe<Scalars['String']>;
  laboratoryId?: InputMaybe<Scalars['String']>;
  laboratoryId_In?: InputMaybe<Scalars['String']>;
};

export enum ClientCompanyGeneticsSource {
  Clones = 'CLONES',
  Seeds = 'SEEDS',
  TissueCulture = 'TISSUE_CULTURE'
}

export enum ClientCompanyGrowingMedia {
  Coco = 'COCO',
  LivingSoil = 'LIVING_SOIL',
  Rockwool = 'ROCKWOOL',
  Soil = 'SOIL'
}

export type ClientCompanyInternal = {
  __typename?: 'ClientCompanyInternal';
  additiveBacterias?: Maybe<Scalars['Boolean']>;
  additiveBloomBooster?: Maybe<Scalars['Boolean']>;
  additiveCarbohydrates?: Maybe<Scalars['Boolean']>;
  additiveColorEnhancer?: Maybe<Scalars['Boolean']>;
  additiveEnzymes?: Maybe<Scalars['Boolean']>;
  additiveFlowerHardener?: Maybe<Scalars['Boolean']>;
  additiveKelpExtract?: Maybe<Scalars['Boolean']>;
  additiveNutritional?: Maybe<Scalars['Boolean']>;
  additivePotencyEnhancer?: Maybe<Scalars['Boolean']>;
  additiveSilica?: Maybe<Scalars['Boolean']>;
  additiveTerpeneEnhancer?: Maybe<Scalars['Boolean']>;
  addressCity: Scalars['String'];
  addressState: Scalars['String'];
  addressStreet: Scalars['String'];
  addressStreet2: Scalars['String'];
  addressZip: Scalars['String'];
  billingEmail: Scalars['String'];
  businessName: Scalars['String'];
  clientUsers: Array<User>;
  containerSize?: Maybe<Scalars['String']>;
  cultivationStyle?: Maybe<ClientCompanyCultivationStyle>;
  dataTracking?: Maybe<Scalars['String']>;
  daysOfFlushBeforeHarvest?: Maybe<Scalars['Int']>;
  easypostAddressId: Scalars['String'];
  environmentalControlSystem?: Maybe<Scalars['String']>;
  facilitySize?: Maybe<Scalars['String']>;
  fertigationSystem?: Maybe<Scalars['String']>;
  flowerRooms?: Maybe<Scalars['Int']>;
  flushBeforeHarvest?: Maybe<Scalars['Boolean']>;
  geneticsSource?: Maybe<ClientCompanyGeneticsSource>;
  goalConsistency?: Maybe<Scalars['Boolean']>;
  goalQuality?: Maybe<Scalars['Boolean']>;
  goalYield?: Maybe<Scalars['Boolean']>;
  growingMedia?: Maybe<ClientCompanyGrowingMedia>;
  harvestsPerYear?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  irrigationFrequency?: Maybe<ClientCompanyIrrigationFrequency>;
  irrigationStyle?: Maybe<ClientCompanyIrrigationStyle>;
  issueBudSize?: Maybe<Scalars['Boolean']>;
  issueConsistency?: Maybe<Scalars['Boolean']>;
  issueCosts?: Maybe<Scalars['Boolean']>;
  issueEnvironmental?: Maybe<Scalars['Boolean']>;
  issuePathogens?: Maybe<Scalars['Boolean']>;
  issuePests?: Maybe<Scalars['Boolean']>;
  issuePlantNutrition?: Maybe<Scalars['Boolean']>;
  issueQuality?: Maybe<Scalars['Boolean']>;
  issueStaffing?: Maybe<Scalars['Boolean']>;
  issueWater?: Maybe<Scalars['Boolean']>;
  issueYield?: Maybe<Scalars['Boolean']>;
  laboratory: Laboratory;
  lightingType?: Maybe<ClientCompanyLightingType>;
  marketDestination?: Maybe<ClientCompanyMarketDestination>;
  motherRooms?: Maybe<Scalars['Int']>;
  notes: Array<LabClientNote>;
  numDaysFlower?: Maybe<Scalars['Int']>;
  numDaysHarvest?: Maybe<Scalars['Int']>;
  numDaysMother?: Maybe<Scalars['Int']>;
  numDaysPropagation?: Maybe<Scalars['Int']>;
  numDaysVeg?: Maybe<Scalars['Int']>;
  numFlagshipStrains?: Maybe<Scalars['Int']>;
  numLights?: Maybe<Scalars['Int']>;
  numSites?: Maybe<Scalars['Int']>;
  numStrains?: Maybe<Scalars['Int']>;
  nutrientLine?: Maybe<Scalars['String']>;
  paymentTerms: ClientCompanyPaymentTerms;
  phone: Scalars['String'];
  potSizeGallon?: Maybe<ClientCompanyPotSizeGallon>;
  propagationRooms?: Maybe<Scalars['Int']>;
  roWaterFiltration?: Maybe<Scalars['Boolean']>;
  runoffVolume?: Maybe<ClientCompanyRunoffVolume>;
  sensorCo2?: Maybe<Scalars['Boolean']>;
  sensorHumidity?: Maybe<Scalars['Boolean']>;
  sensorLight?: Maybe<Scalars['Boolean']>;
  sensorSubstrate?: Maybe<Scalars['Boolean']>;
  sensorTemp?: Maybe<Scalars['Boolean']>;
  sensorVpd?: Maybe<Scalars['Boolean']>;
  sourceCuttings?: Maybe<ClientCompanySourceCuttings>;
  sourceTrim?: Maybe<ClientCompanySourceTrim>;
  vegRooms?: Maybe<Scalars['Int']>;
  waterSource?: Maybe<ClientCompanyWaterSource>;
};

export enum ClientCompanyIrrigationFrequency {
  MultipleShotsPerDay = 'MULTIPLE_SHOTS_PER_DAY',
  SingleLargeVolumePerDay = 'SINGLE_LARGE_VOLUME_PER_DAY'
}

export enum ClientCompanyIrrigationStyle {
  DripEmitters = 'DRIP_EMITTERS',
  EbbNFlow = 'EBB_N_FLOW',
  HandWater = 'HAND_WATER',
  Nft = 'NFT'
}

export enum ClientCompanyLightingType {
  Cmh = 'CMH',
  DoubleEndedHps = 'DOUBLE_ENDED_HPS',
  Led = 'LED',
  Other = 'OTHER'
}

export enum ClientCompanyMarketDestination {
  BrandedPackaging = 'BRANDED_PACKAGING',
  Wholesale = 'WHOLESALE',
  WholesaleAndBranded = 'WHOLESALE_AND_BRANDED'
}

export enum ClientCompanyPaymentTerms {
  Immediate = 'IMMEDIATE',
  Monthly = 'MONTHLY',
  MonthlyPlus_15 = 'MONTHLY_PLUS_15',
  MonthlyPlus_30 = 'MONTHLY_PLUS_30',
  Net_15 = 'NET_15',
  Net_30 = 'NET_30'
}

export enum ClientCompanyPotSizeGallon {
  A_1 = 'A_1',
  A_2 = 'A_2',
  A_3 = 'A_3',
  A_5 = 'A_5',
  A_10 = 'A_10',
  A_20 = 'A_20',
  Other = 'OTHER'
}

export enum ClientCompanyRunoffVolume {
  A_5 = 'A_5',
  A_10 = 'A_10',
  A_15 = 'A_15',
  A_20 = 'A_20',
  A_25 = 'A_25',
  A_30 = 'A_30',
  Other = 'OTHER'
}

export enum ClientCompanySourceCuttings {
  InHouse = 'IN_HOUSE',
  InHouseAndOutsource = 'IN_HOUSE_AND_OUTSOURCE',
  Outsource = 'OUTSOURCE'
}

export enum ClientCompanySourceTrim {
  InHouse = 'IN_HOUSE',
  InHouseAndOutsource = 'IN_HOUSE_AND_OUTSOURCE',
  Outsource = 'OUTSOURCE'
}

export enum ClientCompanyWaterSource {
  City = 'CITY',
  Well = 'WELL'
}

export type CouponCode = {
  __typename?: 'CouponCode';
  claimedCount?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  discountAppliesToShippingCosts: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  freeShippingCostUpToPriceInCents?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  kind: CouponCodeKind;
  laboratory?: Maybe<Laboratory>;
  maxOrdersPerUser: Scalars['Int'];
  maxSamplesPerUser: Scalars['Int'];
  minimumOrderPriceInCents?: Maybe<Scalars['Int']>;
  publicAutomatic: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  usedInOrders: Array<Order>;
  validUntil?: Maybe<Scalars['Date']>;
  value: Scalars['Int'];
};

export type CouponCodeFilterSetInput = {
  id_Icontains?: InputMaybe<Scalars['String']>;
  laboratoryId?: InputMaybe<Scalars['String']>;
  laboratoryId_In?: InputMaybe<Scalars['String']>;
};

export type CouponCodeInput = {
  code: Scalars['String'];
  discountAppliesToShippingCosts?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  freeShippingCostUpToPriceInCents?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<Scalars['String']>;
  maxOrdersPerUser?: InputMaybe<Scalars['Int']>;
  maxSamplesPerUser?: InputMaybe<Scalars['Int']>;
  minimumOrderPriceInCents?: InputMaybe<Scalars['Int']>;
  publicAutomatic?: InputMaybe<Scalars['Boolean']>;
  validUntil?: InputMaybe<Scalars['Date']>;
  value?: InputMaybe<Scalars['Int']>;
};

export enum CouponCodeKind {
  Discount = 'DISCOUNT',
  Percent = 'PERCENT'
}

export type CreateAnalyteHealthRangeInput = {
  analyte: Scalars['String'];
  high: Scalars['Float'];
  low: Scalars['Float'];
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type CreateClientCompany = {
  __typename?: 'CreateClientCompany';
  clientCompany?: Maybe<ClientCompany>;
};

export type CreateClientCompanyInput = {
  addressCity: Scalars['String'];
  addressState: Scalars['String'];
  addressStreet: Scalars['String'];
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressZip: Scalars['String'];
  billingEmail: Scalars['String'];
  businessName: Scalars['String'];
  laboratoryId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateClientCompanyUser = {
  __typename?: 'CreateClientCompanyUser';
  user?: Maybe<User>;
};

export type CreateClientCompanyUserInput = {
  clientCompanyId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  sendInvitation?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCouponCode = {
  __typename?: 'CreateCouponCode';
  couponCode?: Maybe<CouponCode>;
};

export type CreateDummyOrdersInput = {
  clientCompanyId: Scalars['ID'];
  laboratoryId?: InputMaybe<Scalars['ID']>;
  orders: Scalars['Int'];
};

export type CreateDummyOrdersPayload = {
  __typename?: 'CreateDummyOrdersPayload';
  createdOrders: Scalars['Int'];
  createdSamples: Scalars['Int'];
  orders: Array<Order>;
};

export type CreateDummyResultsInput = {
  clientCompanyId: Scalars['ID'];
  laboratoryId?: InputMaybe<Scalars['ID']>;
  maxSamples?: InputMaybe<Scalars['Int']>;
  orderIds: Array<Scalars['ID']>;
};

export type CreateDummyResultsPayload = {
  __typename?: 'CreateDummyResultsPayload';
  samples: Array<Sample>;
  updatedSamples: Scalars['Int'];
};

export type CreateHealthProfile = {
  __typename?: 'CreateHealthProfile';
  healthProfile?: Maybe<HealthProfile>;
};

export type CreateHealthProfileInput = {
  analyteRanges?: InputMaybe<Array<CreateAnalyteHealthRangeInput>>;
  cultivar?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Scalars['String']>;
  testType: Scalars['String'];
  title: Scalars['String'];
};

export type CreateLabClientNote = {
  __typename?: 'CreateLabClientNote';
  note?: Maybe<LabClientNote>;
};

export type CreateLabClientNoteInput = {
  clientCompanyId: Scalars['String'];
  content: Scalars['String'];
};

export type CreateLabUser = {
  __typename?: 'CreateLabUser';
  user?: Maybe<User>;
};

export type CreateLabUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  sendInvitation?: InputMaybe<Scalars['Boolean']>;
  staffAtLaboratoryId: Scalars['String'];
};

export type DeleteClientCompanyUser = {
  __typename?: 'DeleteClientCompanyUser';
  success: Scalars['Boolean'];
};

export type DeleteClientCompanyUserInput = {
  id: Scalars['ID'];
};

export type DeleteLabUser = {
  __typename?: 'DeleteLabUser';
  success: Scalars['Boolean'];
};

export type DeleteLabUserInput = {
  id: Scalars['ID'];
};

export type EditCouponCode = {
  __typename?: 'EditCouponCode';
  couponCode?: Maybe<CouponCode>;
};

export type EditCouponCodeInput = {
  code: Scalars['String'];
  discountAppliesToShippingCosts?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  freeShippingCostUpToPriceInCents?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  kind?: InputMaybe<Scalars['String']>;
  maxOrdersPerUser?: InputMaybe<Scalars['Int']>;
  maxSamplesPerUser?: InputMaybe<Scalars['Int']>;
  minimumOrderPriceInCents?: InputMaybe<Scalars['Int']>;
  publicAutomatic?: InputMaybe<Scalars['Boolean']>;
  validUntil?: InputMaybe<Scalars['Date']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type EditOrder = {
  __typename?: 'EditOrder';
  order?: Maybe<Order>;
};

export type EditOrderInput = {
  clientCompanyId?: InputMaybe<Scalars['ID']>;
  couponCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  laboratoryId?: InputMaybe<Scalars['ID']>;
  shipToBuyerMethod?: InputMaybe<Scalars['String']>;
  shipToLabMethod?: InputMaybe<Scalars['String']>;
  testTypes: Array<InputMaybe<OrderTestTypeSamples>>;
};

export type Error = {
  __typename?: 'Error';
  message: Scalars['String'];
};

export type HealthProfile = {
  __typename?: 'HealthProfile';
  analyteRanges: Array<AnalyteHealthRange>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  cultivar?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  lab: Laboratory;
  stage?: Maybe<HealthProfileStage>;
  testType: HealthProfileTestType;
  title: Scalars['String'];
};

export enum HealthProfileStage {
  A = 'A_',
  Clone = 'CLONE',
  Drying = 'DRYING',
  Flower = 'FLOWER',
  LateFlower = 'LATE_FLOWER',
  Mother = 'MOTHER',
  Veg = 'VEG'
}

export enum HealthProfileTestType {
  Fertilizer = 'FERTILIZER',
  FusariumSpp = 'FUSARIUM_SPP',
  HeavyMetal = 'HEAVY_METAL',
  HopLatentViroid = 'HOP_LATENT_VIROID',
  Nutrient = 'NUTRIENT',
  PlantTissue = 'PLANT_TISSUE',
  PythiumSpp = 'PYTHIUM_SPP',
  RunOff = 'RUN_OFF',
  Soil = 'SOIL',
  Water = 'WATER'
}

export type LabClientNote = {
  __typename?: 'LabClientNote';
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  id: Scalars['ID'];
};

export type Laboratory = {
  __typename?: 'Laboratory';
  accountRegistrationEnabled: Scalars['Boolean'];
  addressCity: Scalars['String'];
  addressState: Scalars['String'];
  addressStreet: Scalars['String'];
  addressStreet2: Scalars['String'];
  addressZip: Scalars['String'];
  businessName: Scalars['String'];
  checkoutCustomerMustBuyReturnLabel: Scalars['Boolean'];
  checkoutCustomerMustBuyShippingLabel: Scalars['Boolean'];
  checkoutEnabled: Scalars['Boolean'];
  customDomain: Scalars['String'];
  easypostAddressId: Scalars['String'];
  freeShippingOver?: Maybe<Scalars['Int']>;
  healthProfiles: Array<HealthProfile>;
  id: Scalars['UUID'];
  logoAsset?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  priceShippingFedexOvernight?: Maybe<Scalars['Int']>;
  priceShippingUspsFirst?: Maybe<Scalars['Int']>;
  priceTestFertilizer?: Maybe<Scalars['Int']>;
  priceTestFusariumSpp?: Maybe<Scalars['Int']>;
  priceTestHeavyMetal?: Maybe<Scalars['Int']>;
  priceTestHopLatentViroid?: Maybe<Scalars['Int']>;
  priceTestNutrient?: Maybe<Scalars['Int']>;
  priceTestPlantTissue?: Maybe<Scalars['Int']>;
  priceTestPythiumSpp?: Maybe<Scalars['Int']>;
  priceTestRunOff?: Maybe<Scalars['Int']>;
  priceTestSoil?: Maybe<Scalars['Int']>;
  priceTestWater?: Maybe<Scalars['Int']>;
  salesEmail: Scalars['String'];
  showTestPrices: Scalars['Boolean'];
  staffUsers: Array<User>;
  supportEmail: Scalars['String'];
  testTypesEnabled?: Maybe<Array<Scalars['String']>>;
};

export type LaboratoryFilterSetInput = {
  businessName_Icontains?: InputMaybe<Scalars['String']>;
  supportEmail_Icontains?: InputMaybe<Scalars['String']>;
};

export type LogoutResult = Error | LogoutSuccess;

export type LogoutSuccess = {
  __typename?: 'LogoutSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  archiveHealthProfile?: Maybe<ArchiveHealthProfile>;
  createClientCompany?: Maybe<CreateClientCompany>;
  createClientCompanyUser?: Maybe<CreateClientCompanyUser>;
  createCouponCode?: Maybe<CreateCouponCode>;
  createDummyOrders?: Maybe<CreateDummyOrdersPayload>;
  createDummyResults?: Maybe<CreateDummyResultsPayload>;
  createHealthProfile?: Maybe<CreateHealthProfile>;
  createLabClientNote?: Maybe<CreateLabClientNote>;
  createLabUser?: Maybe<CreateLabUser>;
  deleteClientCompanyUser?: Maybe<DeleteClientCompanyUser>;
  deleteLabUser?: Maybe<DeleteLabUser>;
  editCouponCode?: Maybe<EditCouponCode>;
  editOrder?: Maybe<EditOrder>;
  logout?: Maybe<LogoutResult>;
  passwordReset?: Maybe<PasswordResetResult>;
  performCheckout?: Maybe<PerformCheckout>;
  quoteCart?: Maybe<QuoteCart>;
  registerUserAndClientCompany?: Maybe<RegisterUserAndClientCompany>;
  sendAccountInvitation?: Maybe<SendAccountInvitation>;
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmailResult>;
  tokenAuth?: Maybe<TokenAuthResult>;
  unarchiveHealthProfile?: Maybe<UnarchiveHealthProfile>;
  updateClientCompany?: Maybe<UpdateClientCompany>;
  updateClientCompanyInternal?: Maybe<UpdateClientCompanyInternal>;
  updateClientCompanyPricing?: Maybe<UpdateClientCompanyPricing>;
  updateHealthProfile?: Maybe<UpdateHealthProfile>;
  updateLaboratory?: Maybe<UpdateLaboratory>;
  updateNotificationEnabled?: Maybe<UpdateNotificationEnabled>;
  updateOrderPaymentStatus?: Maybe<UpdateOrderPaymentStatus>;
  updateOrderProcessStatus?: Maybe<UpdateOrderProcessStatus>;
  updateResults?: Maybe<UpdateResults>;
  updateSampleInfo?: Maybe<UpdateSampleInfo>;
  updateSamplesInfo?: Maybe<UpdateSamplesInfo>;
  updateTrackingColumn?: Maybe<UpdateTrackingColumn>;
  verifyAddress?: Maybe<VerifyAddress>;
};


export type MutationArchiveHealthProfileArgs = {
  id: Scalars['ID'];
};


export type MutationCreateClientCompanyArgs = {
  input?: InputMaybe<CreateClientCompanyInput>;
};


export type MutationCreateClientCompanyUserArgs = {
  input?: InputMaybe<CreateClientCompanyUserInput>;
};


export type MutationCreateCouponCodeArgs = {
  input?: InputMaybe<CouponCodeInput>;
};


export type MutationCreateDummyOrdersArgs = {
  input: CreateDummyOrdersInput;
};


export type MutationCreateDummyResultsArgs = {
  input: CreateDummyResultsInput;
};


export type MutationCreateHealthProfileArgs = {
  input?: InputMaybe<CreateHealthProfileInput>;
};


export type MutationCreateLabClientNoteArgs = {
  input?: InputMaybe<CreateLabClientNoteInput>;
};


export type MutationCreateLabUserArgs = {
  input?: InputMaybe<CreateLabUserInput>;
};


export type MutationDeleteClientCompanyUserArgs = {
  input?: InputMaybe<DeleteClientCompanyUserInput>;
};


export type MutationDeleteLabUserArgs = {
  input?: InputMaybe<DeleteLabUserInput>;
};


export type MutationEditCouponCodeArgs = {
  input?: InputMaybe<EditCouponCodeInput>;
};


export type MutationEditOrderArgs = {
  input?: InputMaybe<EditOrderInput>;
};


export type MutationPasswordResetArgs = {
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
  token: Scalars['String'];
};


export type MutationPerformCheckoutArgs = {
  input?: InputMaybe<PerformCheckoutInput>;
};


export type MutationQuoteCartArgs = {
  input?: InputMaybe<QuoteCartInput>;
};


export type MutationRegisterUserAndClientCompanyArgs = {
  input?: InputMaybe<RegisterUserAndClientCompanyInput>;
};


export type MutationSendAccountInvitationArgs = {
  id: Scalars['ID'];
};


export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type MutationTokenAuthArgs = {
  email_Iexact: Scalars['String'];
  password: Scalars['String'];
};


export type MutationUnarchiveHealthProfileArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateClientCompanyArgs = {
  input?: InputMaybe<UpdateClientCompanyInput>;
};


export type MutationUpdateClientCompanyInternalArgs = {
  input?: InputMaybe<UpdateClientCompanyInternalInput>;
};


export type MutationUpdateClientCompanyPricingArgs = {
  input?: InputMaybe<UpdateClientCompanyPricingInput>;
};


export type MutationUpdateHealthProfileArgs = {
  input?: InputMaybe<UpdateHealthProfileInput>;
};


export type MutationUpdateLaboratoryArgs = {
  input?: InputMaybe<UpdateLaboratoryInput>;
};


export type MutationUpdateNotificationEnabledArgs = {
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};


export type MutationUpdateOrderPaymentStatusArgs = {
  input?: InputMaybe<UpdateOrderPaymentStatusInput>;
};


export type MutationUpdateOrderProcessStatusArgs = {
  input?: InputMaybe<UpdateOrderProcessStatusInput>;
};


export type MutationUpdateResultsArgs = {
  input?: InputMaybe<UpdateResultsInput>;
};


export type MutationUpdateSampleInfoArgs = {
  input?: InputMaybe<UpdateSampleInput>;
};


export type MutationUpdateSamplesInfoArgs = {
  input?: InputMaybe<UpdateSamplesInput>;
};


export type MutationUpdateTrackingColumnArgs = {
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};


export type MutationVerifyAddressArgs = {
  input?: InputMaybe<VerifyAddressInput>;
};

export type Order = {
  __typename?: 'Order';
  clientCompany?: Maybe<ClientCompanyInternal>;
  couponClaimed?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  id: Scalars['String'];
  labelsUrl?: Maybe<Scalars['String']>;
  laboratory?: Maybe<Laboratory>;
  orderDate: Scalars['Date'];
  packingUrl?: Maybe<Scalars['String']>;
  paymentStatus: OrderPaymentStatus;
  pricingInfo: OrderPricing;
  processStatus: OrderProcessStatus;
  samples: Array<Sample>;
  samplesOrdered: Scalars['Int'];
  shipmentToBuyer?: Maybe<Shipment>;
  shipmentToLab?: Maybe<Shipment>;
  stripeInvoiceDueDate?: Maybe<Scalars['Date']>;
  stripeInvoiceId: Scalars['String'];
  totalPriceInCents: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type OrderFilterSetInput = {
  clientCompanyId?: InputMaybe<Scalars['String']>;
  clientCompanyId_In?: InputMaybe<Scalars['String']>;
  createdAt_Gt?: InputMaybe<Scalars['String']>;
  createdAt_Lt?: InputMaybe<Scalars['String']>;
  id_Icontains?: InputMaybe<Scalars['String']>;
  laboratoryId?: InputMaybe<Scalars['String']>;
  laboratoryId_In?: InputMaybe<Scalars['String']>;
  paymentStatus?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  unpaid?: InputMaybe<Scalars['String']>;
};

export type OrderFilterSetOutput = {
  __typename?: 'OrderFilterSetOutput';
  clientCompanyId?: Maybe<Scalars['String']>;
  clientCompanyId_In?: Maybe<Scalars['String']>;
  createdAt_Gt?: Maybe<Scalars['String']>;
  createdAt_Lt?: Maybe<Scalars['String']>;
  id_Icontains?: Maybe<Scalars['String']>;
  laboratoryId?: Maybe<Scalars['String']>;
  laboratoryId_In?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  unpaid?: Maybe<Scalars['String']>;
};

export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  pricePerUnitInCents: Scalars['Int'];
  product: Scalars['String'];
  quantity: Scalars['String'];
  totalInCents: Scalars['Int'];
};

export enum OrderPaymentStatus {
  A = 'A_',
  CheckoutIncomplete = 'CHECKOUT_INCOMPLETE',
  Paid = 'PAID',
  Unpaid = 'UNPAID',
  Voided = 'VOIDED'
}

export type OrderPricing = {
  __typename?: 'OrderPricing';
  clientCompanyId?: Maybe<Scalars['ID']>;
  couponCode?: Maybe<Scalars['String']>;
  couponCodeValid?: Maybe<Scalars['Boolean']>;
  couponDiscountDescription?: Maybe<Scalars['String']>;
  couponDiscountInCents?: Maybe<Scalars['Int']>;
  laboratoryId?: Maybe<Scalars['ID']>;
  lineItems: Array<OrderLineItem>;
  numberOfSamples: Scalars['Int'];
  shipToBuyer?: Maybe<ShippingPricing>;
  shipToLab?: Maybe<ShippingPricing>;
  shippingTotalPriceInCents: Scalars['Int'];
  subtotalPriceInCents: Scalars['Int'];
  totalPriceInCents: Scalars['Int'];
};

export enum OrderProcessStatus {
  AtLab = 'AT_LAB',
  AtSite = 'AT_SITE',
  A = 'A_',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Packaged = 'PACKAGED',
  ReturningToLab = 'RETURNING_TO_LAB',
  SendingToBuyer = 'SENDING_TO_BUYER',
  Unfulfilled = 'UNFULFILLED'
}

export type OrderQuerysetOptionsInput = {
  filters?: InputMaybe<OrderFilterSetInput>;
  paging?: InputMaybe<PagingInput>;
};

export type OrderQuerysetOptionsOutput = {
  __typename?: 'OrderQuerysetOptionsOutput';
  filters: OrderFilterSetOutput;
  paging: PagingInfo;
};

export type OrderQuerysetResult = {
  __typename?: 'OrderQuerysetResult';
  items: Array<Maybe<Order>>;
  options: OrderQuerysetOptionsOutput;
};

export type OrderTestTypeSamples = {
  numberOfSamples: Scalars['Int'];
  pricePerUnitInCents?: InputMaybe<Scalars['Int']>;
  testType: Scalars['String'];
};

export type PagingInfo = {
  __typename?: 'PagingInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  ordering: Scalars['String'];
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  size: Scalars['Int'];
  start: Scalars['Int'];
  totalCount: Scalars['Int'];
  unfilteredCount: Scalars['Int'];
};

export type PagingInput = {
  ordering?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};

export type PasswordResetResult = Error | PasswordResetSuccess;

export type PasswordResetSuccess = {
  __typename?: 'PasswordResetSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type PerformCheckout = {
  __typename?: 'PerformCheckout';
  order?: Maybe<Order>;
  paymentUrl?: Maybe<Scalars['String']>;
  pricing?: Maybe<OrderPricing>;
};

export type PerformCheckoutInput = {
  clientCompanyId?: InputMaybe<Scalars['ID']>;
  couponCode?: InputMaybe<Scalars['String']>;
  laboratoryId?: InputMaybe<Scalars['ID']>;
  paymentToken?: InputMaybe<Scalars['String']>;
  shipToBuyerMethod?: InputMaybe<Scalars['String']>;
  shipToLabMethod?: InputMaybe<Scalars['String']>;
  testTypes: Array<InputMaybe<OrderTestTypeSamples>>;
};

export type Query = {
  __typename?: 'Query';
  getApplicationSettings?: Maybe<ApplicationSettings>;
  getClientCompanies?: Maybe<Array<ClientCompany>>;
  getClientCompany?: Maybe<ClientCompany>;
  getClientCompanyInternal?: Maybe<ClientCompanyInternal>;
  getCouponCodes?: Maybe<Array<Maybe<CouponCode>>>;
  getCurrentLaboratory?: Maybe<Laboratory>;
  getLaboratories?: Maybe<Array<Laboratory>>;
  getLaboratory?: Maybe<Laboratory>;
  getOrder?: Maybe<Order>;
  getOrders?: Maybe<OrderQuerysetResult>;
  getSample?: Maybe<Sample>;
  getSamples?: Maybe<Array<Sample>>;
  getTestResultImports?: Maybe<Array<TestResultImport>>;
  getUsers?: Maybe<Array<User>>;
  myProfile?: Maybe<User>;
  singleAnalyteGroupReports?: Maybe<ReportingSingleAnalyteGroupsOutput>;
};


export type QueryGetClientCompaniesArgs = {
  filters?: InputMaybe<ClientCompanyFilterSetInput>;
};


export type QueryGetClientCompanyArgs = {
  id: Scalars['String'];
};


export type QueryGetClientCompanyInternalArgs = {
  id: Scalars['String'];
};


export type QueryGetCouponCodesArgs = {
  filters?: InputMaybe<CouponCodeFilterSetInput>;
};


export type QueryGetCurrentLaboratoryArgs = {
  domain?: InputMaybe<Scalars['String']>;
};


export type QueryGetLaboratoriesArgs = {
  filters?: InputMaybe<LaboratoryFilterSetInput>;
};


export type QueryGetLaboratoryArgs = {
  id: Scalars['String'];
};


export type QueryGetOrderArgs = {
  id: Scalars['String'];
};


export type QueryGetOrdersArgs = {
  options?: InputMaybe<OrderQuerysetOptionsInput>;
};


export type QueryGetSampleArgs = {
  id: Scalars['String'];
};


export type QueryGetSamplesArgs = {
  filters?: InputMaybe<SampleFilterSetInput>;
};


export type QueryGetUsersArgs = {
  filters?: InputMaybe<UserFilterSetInput>;
};


export type QuerySingleAnalyteGroupReportsArgs = {
  analyte: Scalars['String'];
  filters?: InputMaybe<SampleFilterSetInput>;
  groupingColumn: Scalars['String'];
  xAxis: Scalars['String'];
};

export type QuoteCart = {
  __typename?: 'QuoteCart';
  pricing?: Maybe<OrderPricing>;
};

export type QuoteCartInput = {
  clientCompanyId?: InputMaybe<Scalars['ID']>;
  couponCode?: InputMaybe<Scalars['String']>;
  laboratoryId?: InputMaybe<Scalars['ID']>;
  shipToBuyerMethod?: InputMaybe<Scalars['String']>;
  shipToLabMethod?: InputMaybe<Scalars['String']>;
  testTypes: Array<InputMaybe<OrderTestTypeSamples>>;
};

export type RegisterUserAndClientCompany = {
  __typename?: 'RegisterUserAndClientCompany';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  refreshToken?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
};

export type RegisterUserAndClientCompanyInput = {
  addressCity: Scalars['String'];
  addressState: Scalars['String'];
  addressStreet: Scalars['String'];
  addressZip: Scalars['String'];
  businessName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  laboratoryId: Scalars['String'];
  lastName: Scalars['String'];
  password1: Scalars['String'];
  password2: Scalars['String'];
  phone: Scalars['String'];
};

export type ReportingSingleAnalyteGroupStatValues = {
  __typename?: 'ReportingSingleAnalyteGroupStatValues';
  date: Scalars['String'];
  values: Array<Scalars['Float']>;
};

export type ReportingSingleAnalyteGroupsOutput = {
  __typename?: 'ReportingSingleAnalyteGroupsOutput';
  analyte: Scalars['String'];
  dates: Array<Scalars['String']>;
  groupingColumn: Scalars['String'];
  keys: Array<Scalars['String']>;
  points: Array<ReportingSingleAnalyteGroupStatValues>;
  samples: Array<Sample>;
  title: Scalars['String'];
};

export type Sample = {
  __typename?: 'Sample';
  collectionDate?: Maybe<Scalars['Date']>;
  cultivar: Scalars['String'];
  daysInStage?: Maybe<Scalars['Int']>;
  group: Scalars['String'];
  harvestGroup: Scalars['String'];
  healthProfileId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
  location: Scalars['String'];
  order: Order;
  resultAluminum?: Maybe<Scalars['Decimal']>;
  resultAmmoniumNitrogen?: Maybe<Scalars['Decimal']>;
  resultArsenic?: Maybe<Scalars['Decimal']>;
  resultBoron?: Maybe<Scalars['Decimal']>;
  resultCadmium?: Maybe<Scalars['Decimal']>;
  resultCalcium?: Maybe<Scalars['Decimal']>;
  resultCecEstimation?: Maybe<Scalars['Decimal']>;
  resultCopper?: Maybe<Scalars['Decimal']>;
  resultEc?: Maybe<Scalars['Decimal']>;
  resultFusariumSpp?: Maybe<Scalars['Decimal']>;
  resultHopLatentViroid?: Maybe<Scalars['Decimal']>;
  resultIron?: Maybe<Scalars['Decimal']>;
  resultLead?: Maybe<Scalars['Decimal']>;
  resultMagnesium?: Maybe<Scalars['Decimal']>;
  resultManganese?: Maybe<Scalars['Decimal']>;
  resultMercury?: Maybe<Scalars['Decimal']>;
  resultMolybdenum?: Maybe<Scalars['Decimal']>;
  resultNitrateNitrogen?: Maybe<Scalars['Decimal']>;
  resultNitrogen?: Maybe<Scalars['Decimal']>;
  resultPh?: Maybe<Scalars['Decimal']>;
  resultPhosphorus?: Maybe<Scalars['Decimal']>;
  resultPhosphorusPentoxide?: Maybe<Scalars['Decimal']>;
  resultPotassium?: Maybe<Scalars['Decimal']>;
  resultPotassiumOxide?: Maybe<Scalars['Decimal']>;
  resultPythiumSpp?: Maybe<Scalars['Decimal']>;
  resultSar?: Maybe<Scalars['Decimal']>;
  resultSodium?: Maybe<Scalars['Decimal']>;
  resultSulfur?: Maybe<Scalars['Decimal']>;
  resultTds?: Maybe<Scalars['Decimal']>;
  resultZinc?: Maybe<Scalars['Decimal']>;
  stage?: Maybe<SampleStage>;
  status: SampleStatus;
  testType: SampleTestType;
};

export type SampleFilterSetInput = {
  collectionDate_Gt?: InputMaybe<Scalars['String']>;
  collectionDate_Lt?: InputMaybe<Scalars['String']>;
  cultivar?: InputMaybe<Scalars['String']>;
  daysInStage_Gt?: InputMaybe<Scalars['String']>;
  daysInStage_Lt?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  harvestGroup?: InputMaybe<Scalars['String']>;
  id_Icontains?: InputMaybe<Scalars['String']>;
  label_Icontains?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  order_ClientCompanyId?: InputMaybe<Scalars['String']>;
  order_LaboratoryId?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  testType?: InputMaybe<Scalars['String']>;
};

export enum SampleStage {
  A = 'A_',
  Clone = 'CLONE',
  Drying = 'DRYING',
  Flower = 'FLOWER',
  LateFlower = 'LATE_FLOWER',
  Mother = 'MOTHER',
  Veg = 'VEG'
}

export enum SampleStatus {
  Complete = 'COMPLETE',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Void = 'VOID'
}

export enum SampleTestType {
  Fertilizer = 'FERTILIZER',
  FusariumSpp = 'FUSARIUM_SPP',
  HeavyMetal = 'HEAVY_METAL',
  HopLatentViroid = 'HOP_LATENT_VIROID',
  Nutrient = 'NUTRIENT',
  PlantTissue = 'PLANT_TISSUE',
  PythiumSpp = 'PYTHIUM_SPP',
  RunOff = 'RUN_OFF',
  Soil = 'SOIL',
  Water = 'WATER'
}

export type SendAccountInvitation = {
  __typename?: 'SendAccountInvitation';
  user?: Maybe<User>;
};

export type SendPasswordResetEmailResult = Error | SendPasswordResetEmailSuccess;

export type SendPasswordResetEmailSuccess = {
  __typename?: 'SendPasswordResetEmailSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type Shipment = {
  __typename?: 'Shipment';
  carrier: Scalars['String'];
  createdAt: Scalars['DateTime'];
  estimatedDelivery?: Maybe<Scalars['Date']>;
  fromAddress: Scalars['JSONString'];
  id: Scalars['String'];
  labelUrl: Scalars['String'];
  publicUrl: Scalars['String'];
  toAddress: Scalars['JSONString'];
  trackingLatestDetail?: Maybe<Scalars['JSONString']>;
  trackingStatus: Scalars['String'];
};

export type ShippingPricing = {
  __typename?: 'ShippingPricing';
  method: Scalars['String'];
  priceInCents: Scalars['Int'];
};

export type TestAnalytes = {
  __typename?: 'TestAnalytes';
  analytes: Array<Scalars['String']>;
  testType: Scalars['String'];
};

export type TestResultImport = {
  __typename?: 'TestResultImport';
  createdAt: Scalars['DateTime'];
  file: Scalars['String'];
  fileUrl: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['String'];
  importedBy?: Maybe<User>;
  testType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TokenAuthResult = Error | TokenAuthSuccess;

export type TokenAuthSuccess = {
  __typename?: 'TokenAuthSuccess';
  refreshToken?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type TrackingColumnHistory = {
  __typename?: 'TrackingColumnHistory';
  history: Array<Maybe<Scalars['String']>>;
  name: Scalars['String'];
};

export type UnarchiveHealthProfile = {
  __typename?: 'UnarchiveHealthProfile';
  healthProfile?: Maybe<HealthProfile>;
};

export type UpdateAnalyteHealthRangeInput = {
  analyte: Scalars['String'];
  high?: InputMaybe<Scalars['Float']>;
  low?: InputMaybe<Scalars['Float']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UpdateClientCompany = {
  __typename?: 'UpdateClientCompany';
  clientCompany?: Maybe<ClientCompany>;
};

export type UpdateClientCompanyInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateClientCompanyInternal = {
  __typename?: 'UpdateClientCompanyInternal';
  clientCompany?: Maybe<ClientCompanyInternal>;
};

export type UpdateClientCompanyInternalInput = {
  additiveBacterias?: InputMaybe<Scalars['Boolean']>;
  additiveBloomBooster?: InputMaybe<Scalars['Boolean']>;
  additiveCarbohydrates?: InputMaybe<Scalars['Boolean']>;
  additiveColorEnhancer?: InputMaybe<Scalars['Boolean']>;
  additiveEnzymes?: InputMaybe<Scalars['Boolean']>;
  additiveFlowerHardener?: InputMaybe<Scalars['Boolean']>;
  additiveKelpExtract?: InputMaybe<Scalars['Boolean']>;
  additiveNutritional?: InputMaybe<Scalars['Boolean']>;
  additivePotencyEnhancer?: InputMaybe<Scalars['Boolean']>;
  additiveSilica?: InputMaybe<Scalars['Boolean']>;
  additiveTerpeneEnhancer?: InputMaybe<Scalars['Boolean']>;
  containerSize?: InputMaybe<Scalars['String']>;
  cultivationStyle?: InputMaybe<Scalars['String']>;
  dataTracking?: InputMaybe<Scalars['String']>;
  daysOfFlushBeforeHarvest?: InputMaybe<Scalars['Int']>;
  environmentalControlSystem?: InputMaybe<Scalars['String']>;
  facilitySize?: InputMaybe<Scalars['String']>;
  fertigationSystem?: InputMaybe<Scalars['String']>;
  flowerRooms?: InputMaybe<Scalars['Int']>;
  flushBeforeHarvest?: InputMaybe<Scalars['Boolean']>;
  geneticsSource?: InputMaybe<Scalars['String']>;
  goalConsistency?: InputMaybe<Scalars['Boolean']>;
  goalQuality?: InputMaybe<Scalars['Boolean']>;
  goalYield?: InputMaybe<Scalars['Boolean']>;
  growingMedia?: InputMaybe<Scalars['String']>;
  harvestsPerYear?: InputMaybe<Scalars['Int']>;
  id: Scalars['String'];
  irrigationFrequency?: InputMaybe<Scalars['String']>;
  irrigationStyle?: InputMaybe<Scalars['String']>;
  issueBudSize?: InputMaybe<Scalars['Boolean']>;
  issueConsistency?: InputMaybe<Scalars['Boolean']>;
  issueCosts?: InputMaybe<Scalars['Boolean']>;
  issueEnvironmental?: InputMaybe<Scalars['Boolean']>;
  issuePathogens?: InputMaybe<Scalars['Boolean']>;
  issuePests?: InputMaybe<Scalars['Boolean']>;
  issuePlantNutrition?: InputMaybe<Scalars['Boolean']>;
  issueQuality?: InputMaybe<Scalars['Boolean']>;
  issueStaffing?: InputMaybe<Scalars['Boolean']>;
  issueWater?: InputMaybe<Scalars['Boolean']>;
  issueYield?: InputMaybe<Scalars['Boolean']>;
  lightingType?: InputMaybe<Scalars['String']>;
  marketDestination?: InputMaybe<Scalars['String']>;
  motherRooms?: InputMaybe<Scalars['Int']>;
  numDaysFlower?: InputMaybe<Scalars['Int']>;
  numDaysHarvest?: InputMaybe<Scalars['Int']>;
  numDaysMother?: InputMaybe<Scalars['Int']>;
  numDaysPropagation?: InputMaybe<Scalars['Int']>;
  numDaysVeg?: InputMaybe<Scalars['Int']>;
  numFlagshipStrains?: InputMaybe<Scalars['Int']>;
  numLights?: InputMaybe<Scalars['Int']>;
  numSites?: InputMaybe<Scalars['Int']>;
  numStrains?: InputMaybe<Scalars['Int']>;
  nutrientLine?: InputMaybe<Scalars['String']>;
  potSizeGallon?: InputMaybe<Scalars['String']>;
  propagationRooms?: InputMaybe<Scalars['Int']>;
  roWaterFiltration?: InputMaybe<Scalars['Boolean']>;
  runoffVolume?: InputMaybe<Scalars['String']>;
  sensorCo2?: InputMaybe<Scalars['Boolean']>;
  sensorHumidity?: InputMaybe<Scalars['Boolean']>;
  sensorLight?: InputMaybe<Scalars['Boolean']>;
  sensorSubstrate?: InputMaybe<Scalars['Boolean']>;
  sensorTemp?: InputMaybe<Scalars['Boolean']>;
  sensorVpd?: InputMaybe<Scalars['Boolean']>;
  sourceCuttings?: InputMaybe<Scalars['String']>;
  sourceTrim?: InputMaybe<Scalars['String']>;
  vegRooms?: InputMaybe<Scalars['Int']>;
  waterSource?: InputMaybe<Scalars['String']>;
};

export type UpdateClientCompanyPricing = {
  __typename?: 'UpdateClientCompanyPricing';
  clientCompany?: Maybe<ClientCompany>;
};

export type UpdateClientCompanyPricingInput = {
  id: Scalars['String'];
  paymentTerms?: InputMaybe<Scalars['String']>;
  priceTestFertilizer?: InputMaybe<Scalars['Int']>;
  priceTestFusariumSpp?: InputMaybe<Scalars['Int']>;
  priceTestHeavyMetal?: InputMaybe<Scalars['Int']>;
  priceTestHopLatentViroid?: InputMaybe<Scalars['Int']>;
  priceTestNutrient?: InputMaybe<Scalars['Int']>;
  priceTestPlantTissue?: InputMaybe<Scalars['Int']>;
  priceTestPythiumSpp?: InputMaybe<Scalars['Int']>;
  priceTestRunOff?: InputMaybe<Scalars['Int']>;
  priceTestSoil?: InputMaybe<Scalars['Int']>;
  priceTestWater?: InputMaybe<Scalars['Int']>;
};

export type UpdateHealthProfile = {
  __typename?: 'UpdateHealthProfile';
  healthProfile?: Maybe<HealthProfile>;
};

export type UpdateHealthProfileInput = {
  analyteRanges?: InputMaybe<Array<InputMaybe<UpdateAnalyteHealthRangeInput>>>;
  cultivar?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  stage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UpdateLaboratory = {
  __typename?: 'UpdateLaboratory';
  lab?: Maybe<Laboratory>;
};

export type UpdateLaboratoryInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  freeShippingOver?: InputMaybe<Scalars['Int']>;
  id: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  priceShippingFedexOvernight?: InputMaybe<Scalars['Int']>;
  priceShippingUspsFirst?: InputMaybe<Scalars['Int']>;
  priceTestFertilizer?: InputMaybe<Scalars['Int']>;
  priceTestFusariumSpp?: InputMaybe<Scalars['Int']>;
  priceTestHeavyMetal?: InputMaybe<Scalars['Int']>;
  priceTestHopLatentViroid?: InputMaybe<Scalars['Int']>;
  priceTestNutrient?: InputMaybe<Scalars['Int']>;
  priceTestPlantTissue?: InputMaybe<Scalars['Int']>;
  priceTestPythiumSpp?: InputMaybe<Scalars['Int']>;
  priceTestRunOff?: InputMaybe<Scalars['Int']>;
  priceTestSoil?: InputMaybe<Scalars['Int']>;
  priceTestWater?: InputMaybe<Scalars['Int']>;
  salesEmail?: InputMaybe<Scalars['String']>;
  supportEmail?: InputMaybe<Scalars['String']>;
};

export type UpdateNotificationEnabled = {
  __typename?: 'UpdateNotificationEnabled';
  user?: Maybe<User>;
};

export type UpdateOrderPaymentStatus = {
  __typename?: 'UpdateOrderPaymentStatus';
  order?: Maybe<Order>;
};

export type UpdateOrderPaymentStatusInput = {
  orderId: Scalars['ID'];
  paymentStatus: Scalars['String'];
};

export type UpdateOrderProcessStatus = {
  __typename?: 'UpdateOrderProcessStatus';
  order?: Maybe<Order>;
};

export type UpdateOrderProcessStatusInput = {
  orderId: Scalars['ID'];
  processStatus: Scalars['String'];
};

export type UpdateResults = {
  __typename?: 'UpdateResults';
  errors: Array<Scalars['String']>;
  updated: Array<Sample>;
};

export type UpdateResultsAnalyteInput = {
  analyteId: Scalars['ID'];
  value: Scalars['String'];
};

export type UpdateResultsInput = {
  fileData: Scalars['String'];
  fileName: Scalars['String'];
  samples: Array<InputMaybe<UpdateSampleResultsInput>>;
  testType: Scalars['String'];
};

export type UpdateSampleInfo = {
  __typename?: 'UpdateSampleInfo';
  sample?: Maybe<Sample>;
};

export type UpdateSampleInput = {
  collectionDate?: InputMaybe<Scalars['String']>;
  cultivar?: InputMaybe<Scalars['String']>;
  daysInStage?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Scalars['String']>;
  harvestGroup?: InputMaybe<Scalars['String']>;
  healthProfileId?: InputMaybe<Scalars['ID']>;
  id: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Scalars['String']>;
};

export type UpdateSampleResultsInput = {
  analytes: Array<InputMaybe<UpdateResultsAnalyteInput>>;
  id: Scalars['String'];
};

export type UpdateSamplesInfo = {
  __typename?: 'UpdateSamplesInfo';
  samples?: Maybe<Array<Maybe<Sample>>>;
};

export type UpdateSamplesInput = {
  samples: Array<InputMaybe<UpdateSampleInput>>;
};

export type UpdateTrackingColumn = {
  __typename?: 'UpdateTrackingColumn';
  user?: Maybe<User>;
};

export type User = {
  __typename?: 'User';
  addressCity: Scalars['String'];
  addressState: Scalars['String'];
  addressStreet: Scalars['String'];
  addressZip: Scalars['String'];
  businessName: Scalars['String'];
  clientCompany?: Maybe<ClientCompany>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  isStaff: Scalars['Boolean'];
  lastName: Scalars['String'];
  mostRecentSampleUpdates?: Maybe<Scalars['Date']>;
  notificationsEnabled: Scalars['JSONString'];
  phone: Scalars['String'];
  staffAtLaboratory?: Maybe<Laboratory>;
  trackingColumnsAvailable?: Maybe<Array<Maybe<Scalars['String']>>>;
  trackingColumnsEnabled?: Maybe<Array<Maybe<Scalars['String']>>>;
  trackingColumnsHistories?: Maybe<Array<Maybe<TrackingColumnHistory>>>;
};

export type UserFilterSetInput = {
  clientCompanyId?: InputMaybe<Scalars['String']>;
  clientCompanyId_In?: InputMaybe<Scalars['String']>;
  email_Icontains?: InputMaybe<Scalars['String']>;
};

export type VerifyAddress = {
  __typename?: 'VerifyAddress';
  errors: Array<VerifyAddressError>;
  success: Scalars['Boolean'];
};

export type VerifyAddressError = {
  __typename?: 'VerifyAddressError';
  code: Scalars['String'];
  field?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  suggestion?: Maybe<Scalars['String']>;
};

export type VerifyAddressInput = {
  addressCity: Scalars['String'];
  addressState: Scalars['String'];
  addressStreet: Scalars['String'];
  addressStreet2: Scalars['String'];
  addressZip: Scalars['String'];
  businessName: Scalars['String'];
  id: Scalars['String'];
  phone: Scalars['String'];
};

export type GetApplicationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApplicationSettingsQuery = { __typename?: 'Query', getApplicationSettings?: { __typename?: 'ApplicationSettings', analytes: Array<{ __typename?: 'AnalyteInfo', id: string, label: string, measurementUnit: string, nicknames: Array<string>, group: string }>, testAnalytes: Array<{ __typename?: 'TestAnalytes', testType: string, analytes: Array<string> }> } | null };

export type GetSiteLabQueryVariables = Exact<{
  domain?: InputMaybe<Scalars['String']>;
}>;


export type GetSiteLabQuery = { __typename?: 'Query', getCurrentLaboratory?: { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> } | null };

export type ApplicationSettingsFragment = { __typename?: 'ApplicationSettings', analytes: Array<{ __typename?: 'AnalyteInfo', id: string, label: string, measurementUnit: string, nicknames: Array<string>, group: string }>, testAnalytes: Array<{ __typename?: 'TestAnalytes', testType: string, analytes: Array<string> }> };

export type AnalyteInfoFragment = { __typename?: 'AnalyteInfo', id: string, label: string, measurementUnit: string, nicknames: Array<string>, group: string };

export type TestAnalytesFragment = { __typename?: 'TestAnalytes', testType: string, analytes: Array<string> };

export type QuoteCartMutationVariables = Exact<{
  input?: InputMaybe<QuoteCartInput>;
}>;


export type QuoteCartMutation = { __typename?: 'Mutation', quoteCart?: { __typename?: 'QuoteCart', pricing?: { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null } | null } | null };

export type PerformCheckoutMutationVariables = Exact<{
  input?: InputMaybe<PerformCheckoutInput>;
}>;


export type PerformCheckoutMutation = { __typename?: 'Mutation', performCheckout?: { __typename?: 'PerformCheckout', paymentUrl?: string | null, order?: { __typename?: 'Order', id: string, samplesOrdered: number, orderDate: any, couponClaimed?: string | null, totalPriceInCents: number, paymentStatus: OrderPaymentStatus, processStatus: OrderProcessStatus, labelsUrl?: string | null, packingUrl?: string | null, samples: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null }>, pricingInfo: { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null }, shipmentToBuyer?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, shipmentToLab?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, clientCompany?: { __typename?: 'ClientCompanyInternal', businessName: string, id: any } | null } | null, pricing?: { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null } | null } | null };

export type PricingFieldsFragment = { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null };

export type CreateDummyOrdersMutationVariables = Exact<{
  input: CreateDummyOrdersInput;
}>;


export type CreateDummyOrdersMutation = { __typename?: 'Mutation', createDummyOrders?: { __typename?: 'CreateDummyOrdersPayload', createdOrders: number, createdSamples: number, orders: Array<{ __typename?: 'Order', id: string, samplesOrdered: number, orderDate: any, couponClaimed?: string | null, totalPriceInCents: number, paymentStatus: OrderPaymentStatus, processStatus: OrderProcessStatus, labelsUrl?: string | null, packingUrl?: string | null, samples: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null }>, pricingInfo: { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null }, shipmentToBuyer?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, shipmentToLab?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, clientCompany?: { __typename?: 'ClientCompanyInternal', businessName: string, id: any } | null }> } | null };

export type CreateDummyResultsMutationVariables = Exact<{
  input: CreateDummyResultsInput;
}>;


export type CreateDummyResultsMutation = { __typename?: 'Mutation', createDummyResults?: { __typename?: 'CreateDummyResultsPayload', updatedSamples: number, samples: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null, resultNitrogen?: any | null, resultPotassium?: any | null, resultPhosphorus?: any | null, resultSulfur?: any | null, resultCalcium?: any | null, resultMagnesium?: any | null, resultManganese?: any | null, resultIron?: any | null, resultMolybdenum?: any | null, resultCopper?: any | null, resultBoron?: any | null, resultZinc?: any | null, resultAluminum?: any | null, resultSodium?: any | null, resultPh?: any | null, resultEc?: any | null, resultSar?: any | null, resultCecEstimation?: any | null, resultTds?: any | null, resultAmmoniumNitrogen?: any | null, resultNitrateNitrogen?: any | null, resultPhosphorusPentoxide?: any | null, resultPotassiumOxide?: any | null, resultArsenic?: any | null, resultCadmium?: any | null, resultLead?: any | null, resultMercury?: any | null, resultHopLatentViroid?: any | null, resultFusariumSpp?: any | null, resultPythiumSpp?: any | null }> } | null };

export type GetOrdersQueryVariables = Exact<{
  options?: InputMaybe<OrderQuerysetOptionsInput>;
}>;


export type GetOrdersQuery = { __typename?: 'Query', getOrders?: { __typename?: 'OrderQuerysetResult', options: { __typename?: 'OrderQuerysetOptionsOutput', paging: { __typename?: 'PagingInfo', totalCount: number, pageCount: number, size: number, start: number, page: number, hasNextPage: boolean, hasPreviousPage: boolean }, filters: { __typename?: 'OrderFilterSetOutput', search?: string | null } }, items: Array<{ __typename?: 'Order', id: string, samplesOrdered: number, orderDate: any, couponClaimed?: string | null, totalPriceInCents: number, paymentStatus: OrderPaymentStatus, processStatus: OrderProcessStatus, labelsUrl?: string | null, packingUrl?: string | null, samples: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null }>, pricingInfo: { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null }, shipmentToBuyer?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, shipmentToLab?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, clientCompany?: { __typename?: 'ClientCompanyInternal', businessName: string, id: any } | null } | null> } | null };

export type PagingInfoFragment = { __typename?: 'PagingInfo', totalCount: number, pageCount: number, size: number, start: number, page: number, hasNextPage: boolean, hasPreviousPage: boolean };

export type OrderPaginatedResultFragment = { __typename?: 'OrderQuerysetResult', options: { __typename?: 'OrderQuerysetOptionsOutput', paging: { __typename?: 'PagingInfo', totalCount: number, pageCount: number, size: number, start: number, page: number, hasNextPage: boolean, hasPreviousPage: boolean }, filters: { __typename?: 'OrderFilterSetOutput', search?: string | null } }, items: Array<{ __typename?: 'Order', id: string, samplesOrdered: number, orderDate: any, couponClaimed?: string | null, totalPriceInCents: number, paymentStatus: OrderPaymentStatus, processStatus: OrderProcessStatus, labelsUrl?: string | null, packingUrl?: string | null, samples: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null }>, pricingInfo: { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null }, shipmentToBuyer?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, shipmentToLab?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, clientCompany?: { __typename?: 'ClientCompanyInternal', businessName: string, id: any } | null } | null> };

export type GetOrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrderQuery = { __typename?: 'Query', getOrder?: { __typename?: 'Order', id: string, samplesOrdered: number, orderDate: any, couponClaimed?: string | null, totalPriceInCents: number, paymentStatus: OrderPaymentStatus, processStatus: OrderProcessStatus, labelsUrl?: string | null, packingUrl?: string | null, samples: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null }>, pricingInfo: { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null }, shipmentToBuyer?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, shipmentToLab?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, clientCompany?: { __typename?: 'ClientCompanyInternal', businessName: string, id: any } | null } | null };

export type GetCouponCodesQueryVariables = Exact<{
  filters?: InputMaybe<CouponCodeFilterSetInput>;
}>;


export type GetCouponCodesQuery = { __typename?: 'Query', getCouponCodes?: Array<{ __typename?: 'CouponCode', id: any, code: string, enabled: boolean, publicAutomatic: boolean, kind: CouponCodeKind, value: number, minimumOrderPriceInCents?: number | null, maxOrdersPerUser: number, maxSamplesPerUser: number, validUntil?: any | null, discountAppliesToShippingCosts: boolean, freeShippingCostUpToPriceInCents?: number | null, claimedCount?: number | null } | null> | null };

export type UpdateOrderProcessStatusMutationVariables = Exact<{
  input: UpdateOrderProcessStatusInput;
}>;


export type UpdateOrderProcessStatusMutation = { __typename?: 'Mutation', updateOrderProcessStatus?: { __typename?: 'UpdateOrderProcessStatus', order?: { __typename?: 'Order', id: string, samplesOrdered: number, orderDate: any, couponClaimed?: string | null, totalPriceInCents: number, paymentStatus: OrderPaymentStatus, processStatus: OrderProcessStatus, labelsUrl?: string | null, packingUrl?: string | null, samples: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null }>, pricingInfo: { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null }, shipmentToBuyer?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, shipmentToLab?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, clientCompany?: { __typename?: 'ClientCompanyInternal', businessName: string, id: any } | null } | null } | null };

export type UpdateOrderPaymentStatusMutationVariables = Exact<{
  input: UpdateOrderPaymentStatusInput;
}>;


export type UpdateOrderPaymentStatusMutation = { __typename?: 'Mutation', updateOrderPaymentStatus?: { __typename?: 'UpdateOrderPaymentStatus', order?: { __typename?: 'Order', id: string, samplesOrdered: number, orderDate: any, couponClaimed?: string | null, totalPriceInCents: number, paymentStatus: OrderPaymentStatus, processStatus: OrderProcessStatus, labelsUrl?: string | null, packingUrl?: string | null, samples: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null }>, pricingInfo: { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null }, shipmentToBuyer?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, shipmentToLab?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, clientCompany?: { __typename?: 'ClientCompanyInternal', businessName: string, id: any } | null } | null } | null };

export type CreateCouponCodeMutationVariables = Exact<{
  input: CouponCodeInput;
}>;


export type CreateCouponCodeMutation = { __typename?: 'Mutation', createCouponCode?: { __typename?: 'CreateCouponCode', couponCode?: { __typename?: 'CouponCode', id: any, code: string, enabled: boolean, publicAutomatic: boolean, kind: CouponCodeKind, value: number, minimumOrderPriceInCents?: number | null, maxOrdersPerUser: number, maxSamplesPerUser: number, validUntil?: any | null, discountAppliesToShippingCosts: boolean, freeShippingCostUpToPriceInCents?: number | null, claimedCount?: number | null } | null } | null };

export type EditCouponCodeMutationVariables = Exact<{
  input: EditCouponCodeInput;
}>;


export type EditCouponCodeMutation = { __typename?: 'Mutation', editCouponCode?: { __typename?: 'EditCouponCode', couponCode?: { __typename?: 'CouponCode', id: any, code: string, enabled: boolean, publicAutomatic: boolean, kind: CouponCodeKind, value: number, minimumOrderPriceInCents?: number | null, maxOrdersPerUser: number, maxSamplesPerUser: number, validUntil?: any | null, discountAppliesToShippingCosts: boolean, freeShippingCostUpToPriceInCents?: number | null, claimedCount?: number | null } | null } | null };

export type EditOrderMutationVariables = Exact<{
  input: EditOrderInput;
}>;


export type EditOrderMutation = { __typename?: 'Mutation', editOrder?: { __typename?: 'EditOrder', order?: { __typename?: 'Order', id: string, samplesOrdered: number, orderDate: any, couponClaimed?: string | null, totalPriceInCents: number, paymentStatus: OrderPaymentStatus, processStatus: OrderProcessStatus, labelsUrl?: string | null, packingUrl?: string | null, samples: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null }>, pricingInfo: { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null }, shipmentToBuyer?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, shipmentToLab?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, clientCompany?: { __typename?: 'ClientCompanyInternal', businessName: string, id: any } | null } | null } | null };

export type CouponCodeFieldsFragment = { __typename?: 'CouponCode', id: any, code: string, enabled: boolean, publicAutomatic: boolean, kind: CouponCodeKind, value: number, minimumOrderPriceInCents?: number | null, maxOrdersPerUser: number, maxSamplesPerUser: number, validUntil?: any | null, discountAppliesToShippingCosts: boolean, freeShippingCostUpToPriceInCents?: number | null, claimedCount?: number | null };

export type OrderSummaryFieldsFragment = { __typename?: 'Order', id: string, samplesOrdered: number, orderDate: any, couponClaimed?: string | null, totalPriceInCents: number, paymentStatus: OrderPaymentStatus, processStatus: OrderProcessStatus, labelsUrl?: string | null, packingUrl?: string | null, pricingInfo: { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null }, shipmentToBuyer?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, shipmentToLab?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, clientCompany?: { __typename?: 'ClientCompanyInternal', businessName: string, id: any } | null };

export type OrderWithSamplesFragment = { __typename?: 'Order', id: string, samplesOrdered: number, orderDate: any, couponClaimed?: string | null, totalPriceInCents: number, paymentStatus: OrderPaymentStatus, processStatus: OrderProcessStatus, labelsUrl?: string | null, packingUrl?: string | null, samples: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null }>, pricingInfo: { __typename?: 'OrderPricing', couponCode?: string | null, couponCodeValid?: boolean | null, couponDiscountDescription?: string | null, couponDiscountInCents?: number | null, numberOfSamples: number, shippingTotalPriceInCents: number, subtotalPriceInCents: number, totalPriceInCents: number, lineItems: Array<{ __typename?: 'OrderLineItem', product: string, quantity: string, pricePerUnitInCents: number, totalInCents: number }>, shipToBuyer?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null, shipToLab?: { __typename?: 'ShippingPricing', method: string, priceInCents: number } | null }, shipmentToBuyer?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, shipmentToLab?: { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null } | null, clientCompany?: { __typename?: 'ClientCompanyInternal', businessName: string, id: any } | null };

export type ShipmentSummaryFieldsFragment = { __typename?: 'Shipment', id: string, carrier: string, createdAt: any, fromAddress: any, toAddress: any, labelUrl: string, publicUrl: string, trackingStatus: string, trackingLatestDetail?: any | null, estimatedDelivery?: any | null };

export type SingleAnalyteGroupReportsQueryVariables = Exact<{
  groupingColumn: Scalars['String'];
  analyte: Scalars['String'];
  xAxis: Scalars['String'];
  filters?: InputMaybe<SampleFilterSetInput>;
}>;


export type SingleAnalyteGroupReportsQuery = { __typename?: 'Query', singleAnalyteGroupReports?: { __typename?: 'ReportingSingleAnalyteGroupsOutput', analyte: string, groupingColumn: string, title: string, keys: Array<string>, dates: Array<string>, samples: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null, resultNitrogen?: any | null, resultPotassium?: any | null, resultPhosphorus?: any | null, resultSulfur?: any | null, resultCalcium?: any | null, resultMagnesium?: any | null, resultManganese?: any | null, resultIron?: any | null, resultMolybdenum?: any | null, resultCopper?: any | null, resultBoron?: any | null, resultZinc?: any | null, resultAluminum?: any | null, resultSodium?: any | null, resultPh?: any | null, resultEc?: any | null, resultSar?: any | null, resultCecEstimation?: any | null, resultTds?: any | null, resultAmmoniumNitrogen?: any | null, resultNitrateNitrogen?: any | null, resultPhosphorusPentoxide?: any | null, resultPotassiumOxide?: any | null, resultArsenic?: any | null, resultCadmium?: any | null, resultLead?: any | null, resultMercury?: any | null, resultHopLatentViroid?: any | null, resultFusariumSpp?: any | null, resultPythiumSpp?: any | null }>, points: Array<{ __typename?: 'ReportingSingleAnalyteGroupStatValues', values: Array<number>, date: string }> } | null };

export type SingleAnalyteGroupReportFieldsFragment = { __typename?: 'ReportingSingleAnalyteGroupsOutput', analyte: string, groupingColumn: string, title: string, keys: Array<string>, dates: Array<string>, samples: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null, resultNitrogen?: any | null, resultPotassium?: any | null, resultPhosphorus?: any | null, resultSulfur?: any | null, resultCalcium?: any | null, resultMagnesium?: any | null, resultManganese?: any | null, resultIron?: any | null, resultMolybdenum?: any | null, resultCopper?: any | null, resultBoron?: any | null, resultZinc?: any | null, resultAluminum?: any | null, resultSodium?: any | null, resultPh?: any | null, resultEc?: any | null, resultSar?: any | null, resultCecEstimation?: any | null, resultTds?: any | null, resultAmmoniumNitrogen?: any | null, resultNitrateNitrogen?: any | null, resultPhosphorusPentoxide?: any | null, resultPotassiumOxide?: any | null, resultArsenic?: any | null, resultCadmium?: any | null, resultLead?: any | null, resultMercury?: any | null, resultHopLatentViroid?: any | null, resultFusariumSpp?: any | null, resultPythiumSpp?: any | null }>, points: Array<{ __typename?: 'ReportingSingleAnalyteGroupStatValues', values: Array<number>, date: string }> };

export type SampleFilterResultsQueryVariables = Exact<{
  filters: SampleFilterSetInput;
}>;


export type SampleFilterResultsQuery = { __typename?: 'Query', getSamples?: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null, resultNitrogen?: any | null, resultPotassium?: any | null, resultPhosphorus?: any | null, resultSulfur?: any | null, resultCalcium?: any | null, resultMagnesium?: any | null, resultManganese?: any | null, resultIron?: any | null, resultMolybdenum?: any | null, resultCopper?: any | null, resultBoron?: any | null, resultZinc?: any | null, resultAluminum?: any | null, resultSodium?: any | null, resultPh?: any | null, resultEc?: any | null, resultSar?: any | null, resultCecEstimation?: any | null, resultTds?: any | null, resultAmmoniumNitrogen?: any | null, resultNitrateNitrogen?: any | null, resultPhosphorusPentoxide?: any | null, resultPotassiumOxide?: any | null, resultArsenic?: any | null, resultCadmium?: any | null, resultLead?: any | null, resultMercury?: any | null, resultHopLatentViroid?: any | null, resultFusariumSpp?: any | null, resultPythiumSpp?: any | null }> | null };

export type LabSamplesQueryVariables = Exact<{
  filters: SampleFilterSetInput;
}>;


export type LabSamplesQuery = { __typename?: 'Query', getSamples?: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null, order: { __typename?: 'Order', id: string, orderDate: any, clientCompany?: { __typename?: 'ClientCompanyInternal', id: any, businessName: string } | null } }> | null };

export type LabSamplesFieldsFragment = { __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null, order: { __typename?: 'Order', id: string, orderDate: any, clientCompany?: { __typename?: 'ClientCompanyInternal', id: any, businessName: string } | null } };

export type SampleFullFieldsFragment = { __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null, resultNitrogen?: any | null, resultPotassium?: any | null, resultPhosphorus?: any | null, resultSulfur?: any | null, resultCalcium?: any | null, resultMagnesium?: any | null, resultManganese?: any | null, resultIron?: any | null, resultMolybdenum?: any | null, resultCopper?: any | null, resultBoron?: any | null, resultZinc?: any | null, resultAluminum?: any | null, resultSodium?: any | null, resultPh?: any | null, resultEc?: any | null, resultSar?: any | null, resultCecEstimation?: any | null, resultTds?: any | null, resultAmmoniumNitrogen?: any | null, resultNitrateNitrogen?: any | null, resultPhosphorusPentoxide?: any | null, resultPotassiumOxide?: any | null, resultArsenic?: any | null, resultCadmium?: any | null, resultLead?: any | null, resultMercury?: any | null, resultHopLatentViroid?: any | null, resultFusariumSpp?: any | null, resultPythiumSpp?: any | null };

export type GetCompleteSamplesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompleteSamplesQuery = { __typename?: 'Query', getSamples?: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null, resultNitrogen?: any | null, resultPotassium?: any | null, resultPhosphorus?: any | null, resultSulfur?: any | null, resultCalcium?: any | null, resultMagnesium?: any | null, resultManganese?: any | null, resultIron?: any | null, resultMolybdenum?: any | null, resultCopper?: any | null, resultBoron?: any | null, resultZinc?: any | null, resultAluminum?: any | null, resultSodium?: any | null, resultPh?: any | null, resultEc?: any | null, resultSar?: any | null, resultCecEstimation?: any | null, resultTds?: any | null, resultAmmoniumNitrogen?: any | null, resultNitrateNitrogen?: any | null, resultPhosphorusPentoxide?: any | null, resultPotassiumOxide?: any | null, resultArsenic?: any | null, resultCadmium?: any | null, resultLead?: any | null, resultMercury?: any | null, resultHopLatentViroid?: any | null, resultFusariumSpp?: any | null, resultPythiumSpp?: any | null }> | null };

export type GetSampleIdsQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']>;
}>;


export type GetSampleIdsQuery = { __typename?: 'Query', getSamples?: Array<{ __typename?: 'Sample', id: string }> | null };

export type UpdateSampleInfoMutationVariables = Exact<{
  input: UpdateSampleInput;
}>;


export type UpdateSampleInfoMutation = { __typename?: 'Mutation', updateSampleInfo?: { __typename?: 'UpdateSampleInfo', sample?: { __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null } | null } | null };

export type UpdateSamplesInfoMutationVariables = Exact<{
  input: UpdateSamplesInput;
}>;


export type UpdateSamplesInfoMutation = { __typename?: 'Mutation', updateSamplesInfo?: { __typename?: 'UpdateSamplesInfo', samples?: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null } | null> | null } | null };

export type UpdateResultsMutationVariables = Exact<{
  input: UpdateResultsInput;
}>;


export type UpdateResultsMutation = { __typename?: 'Mutation', updateResults?: { __typename?: 'UpdateResults', errors: Array<string>, updated: Array<{ __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null, resultNitrogen?: any | null, resultPotassium?: any | null, resultPhosphorus?: any | null, resultSulfur?: any | null, resultCalcium?: any | null, resultMagnesium?: any | null, resultManganese?: any | null, resultIron?: any | null, resultMolybdenum?: any | null, resultCopper?: any | null, resultBoron?: any | null, resultZinc?: any | null, resultAluminum?: any | null, resultSodium?: any | null, resultPh?: any | null, resultEc?: any | null, resultSar?: any | null, resultCecEstimation?: any | null, resultTds?: any | null, resultAmmoniumNitrogen?: any | null, resultNitrateNitrogen?: any | null, resultPhosphorusPentoxide?: any | null, resultPotassiumOxide?: any | null, resultArsenic?: any | null, resultCadmium?: any | null, resultLead?: any | null, resultMercury?: any | null, resultHopLatentViroid?: any | null, resultFusariumSpp?: any | null, resultPythiumSpp?: any | null }> } | null };

export type SampleResultFieldsFragment = { __typename?: 'Sample', id: string, resultNitrogen?: any | null, resultPotassium?: any | null, resultPhosphorus?: any | null, resultSulfur?: any | null, resultCalcium?: any | null, resultMagnesium?: any | null, resultManganese?: any | null, resultIron?: any | null, resultMolybdenum?: any | null, resultCopper?: any | null, resultBoron?: any | null, resultZinc?: any | null, resultAluminum?: any | null, resultSodium?: any | null, resultPh?: any | null, resultEc?: any | null, resultSar?: any | null, resultCecEstimation?: any | null, resultTds?: any | null, resultAmmoniumNitrogen?: any | null, resultNitrateNitrogen?: any | null, resultPhosphorusPentoxide?: any | null, resultPotassiumOxide?: any | null, resultArsenic?: any | null, resultCadmium?: any | null, resultLead?: any | null, resultMercury?: any | null, resultHopLatentViroid?: any | null, resultFusariumSpp?: any | null, resultPythiumSpp?: any | null };

export type SampleSummaryFieldsFragment = { __typename?: 'Sample', id: string, status: SampleStatus, label: string, group: string, testType: SampleTestType, stage?: SampleStage | null, daysInStage?: number | null, location: string, harvestGroup: string, cultivar: string, collectionDate?: any | null, healthProfileId?: string | null };

export type TestResultImportFieldsFragment = { __typename?: 'TestResultImport', id: string, createdAt: any, filename: string, testType: string, fileUrl: string, importedBy?: { __typename?: 'User', id: any, email: string, firstName: string, lastName: string } | null };

export type GetTestResultImportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTestResultImportsQuery = { __typename?: 'Query', getTestResultImports?: Array<{ __typename?: 'TestResultImport', id: string, createdAt: any, filename: string, testType: string, fileUrl: string, importedBy?: { __typename?: 'User', id: any, email: string, firstName: string, lastName: string } | null }> | null };

export type MyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileQuery = { __typename?: 'Query', myProfile?: { __typename?: 'User', id: any, isStaff: boolean, email: string, firstName: string, lastName: string, businessName: string, phone: string, trackingColumnsEnabled?: Array<string | null> | null, notificationsEnabled: any, trackingColumnsAvailable?: Array<string | null> | null, mostRecentSampleUpdates?: any | null, clientCompany?: { __typename?: 'ClientCompany', id: any, businessName: string, addressStreet: string, addressCity: string, addressState: string, addressZip: string, phone: string, billingEmail: string, addressStreet2: string, paymentTerms: ClientCompanyPaymentTerms, easypostAddressId: string, laboratory: { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> } } | null, staffAtLaboratory?: { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> } | null } | null };

export type GetUsersQueryVariables = Exact<{
  filters?: InputMaybe<UserFilterSetInput>;
}>;


export type GetUsersQuery = { __typename?: 'Query', getUsers?: Array<{ __typename?: 'User', id: any, isStaff: boolean, email: string, firstName: string, lastName: string, businessName: string, phone: string, trackingColumnsEnabled?: Array<string | null> | null, notificationsEnabled: any, trackingColumnsAvailable?: Array<string | null> | null, mostRecentSampleUpdates?: any | null, clientCompany?: { __typename?: 'ClientCompany', id: any, businessName: string, addressStreet: string, addressCity: string, addressState: string, addressZip: string, phone: string, billingEmail: string, addressStreet2: string, paymentTerms: ClientCompanyPaymentTerms, easypostAddressId: string, laboratory: { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> } } | null, staffAtLaboratory?: { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> } | null }> | null };

export type GetClientCompaniesQueryVariables = Exact<{
  filters?: InputMaybe<ClientCompanyFilterSetInput>;
}>;


export type GetClientCompaniesQuery = { __typename?: 'Query', getClientCompanies?: Array<{ __typename?: 'ClientCompany', id: any, businessName: string, addressStreet: string, addressCity: string, addressState: string, addressZip: string, phone: string, billingEmail: string, addressStreet2: string, paymentTerms: ClientCompanyPaymentTerms, easypostAddressId: string, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null }> | null };

export type GetClientCompanyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetClientCompanyQuery = { __typename?: 'Query', getClientCompany?: { __typename?: 'ClientCompany', id: any, businessName: string, addressStreet: string, addressCity: string, addressState: string, addressZip: string, phone: string, billingEmail: string, addressStreet2: string, paymentTerms: ClientCompanyPaymentTerms, easypostAddressId: string, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, clientUsers: Array<{ __typename?: 'User', id: any, firstName: string, lastName: string, email: string }> } | null };

export type GetClientCompanyInternalQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetClientCompanyInternalQuery = { __typename?: 'Query', getClientCompanyInternal?: { __typename?: 'ClientCompanyInternal', id: any, cultivationStyle?: ClientCompanyCultivationStyle | null, paymentTerms: ClientCompanyPaymentTerms, numDaysMother?: number | null, numDaysPropagation?: number | null, numDaysVeg?: number | null, numDaysFlower?: number | null, numDaysHarvest?: number | null, harvestsPerYear?: number | null, motherRooms?: number | null, vegRooms?: number | null, flowerRooms?: number | null, propagationRooms?: number | null, roWaterFiltration?: boolean | null, sourceCuttings?: ClientCompanySourceCuttings | null, sourceTrim?: ClientCompanySourceTrim | null, dataTracking?: string | null, growingMedia?: ClientCompanyGrowingMedia | null, containerSize?: string | null, nutrientLine?: string | null, facilitySize?: string | null, numLights?: number | null, numSites?: number | null, potSizeGallon?: ClientCompanyPotSizeGallon | null, marketDestination?: ClientCompanyMarketDestination | null, waterSource?: ClientCompanyWaterSource | null, geneticsSource?: ClientCompanyGeneticsSource | null, lightingType?: ClientCompanyLightingType | null, numStrains?: number | null, numFlagshipStrains?: number | null, irrigationStyle?: ClientCompanyIrrigationStyle | null, irrigationFrequency?: ClientCompanyIrrigationFrequency | null, fertigationSystem?: string | null, flushBeforeHarvest?: boolean | null, daysOfFlushBeforeHarvest?: number | null, runoffVolume?: ClientCompanyRunoffVolume | null, environmentalControlSystem?: string | null, issueYield?: boolean | null, issueQuality?: boolean | null, issueConsistency?: boolean | null, issuePests?: boolean | null, issuePathogens?: boolean | null, issueBudSize?: boolean | null, issueWater?: boolean | null, issueEnvironmental?: boolean | null, issueCosts?: boolean | null, issuePlantNutrition?: boolean | null, issueStaffing?: boolean | null, goalYield?: boolean | null, goalQuality?: boolean | null, goalConsistency?: boolean | null, additiveBacterias?: boolean | null, additiveEnzymes?: boolean | null, additiveCarbohydrates?: boolean | null, additiveKelpExtract?: boolean | null, additiveSilica?: boolean | null, additiveBloomBooster?: boolean | null, additiveFlowerHardener?: boolean | null, additiveTerpeneEnhancer?: boolean | null, additivePotencyEnhancer?: boolean | null, additiveColorEnhancer?: boolean | null, additiveNutritional?: boolean | null, sensorTemp?: boolean | null, sensorHumidity?: boolean | null, sensorCo2?: boolean | null, sensorLight?: boolean | null, sensorSubstrate?: boolean | null, sensorVpd?: boolean | null, notes: Array<{ __typename?: 'LabClientNote', id: string, content: string, createdAt: any, createdBy?: { __typename?: 'User', id: any, firstName: string, lastName: string } | null }> } | null };

export type GetLaboratoriesQueryVariables = Exact<{
  filters?: InputMaybe<LaboratoryFilterSetInput>;
}>;


export type GetLaboratoriesQuery = { __typename?: 'Query', getLaboratories?: Array<{ __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> }> | null };

export type GetLaboratoryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLaboratoryQuery = { __typename?: 'Query', getLaboratory?: { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, staffUsers: Array<{ __typename?: 'User', id: any, firstName: string, lastName: string, email: string, staffAtLaboratory?: { __typename?: 'Laboratory', id: any } | null }>, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> } | null };

export type TrackingColumnsHistoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type TrackingColumnsHistoriesQuery = { __typename?: 'Query', myProfile?: { __typename?: 'User', id: any, trackingColumnsHistories?: Array<{ __typename?: 'TrackingColumnHistory', name: string, history: Array<string | null> } | null> | null } | null };

export type UpdateLaboratoryMutationVariables = Exact<{
  input: UpdateLaboratoryInput;
}>;


export type UpdateLaboratoryMutation = { __typename?: 'Mutation', updateLaboratory?: { __typename?: 'UpdateLaboratory', lab?: { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> } | null } | null };

export type CreateLabUserMutationVariables = Exact<{
  input: CreateLabUserInput;
}>;


export type CreateLabUserMutation = { __typename?: 'Mutation', createLabUser?: { __typename?: 'CreateLabUser', user?: { __typename?: 'User', id: any, firstName: string, lastName: string, email: string, staffAtLaboratory?: { __typename?: 'Laboratory', id: any } | null } | null } | null };

export type DeleteLabUserMutationVariables = Exact<{
  input: DeleteLabUserInput;
}>;


export type DeleteLabUserMutation = { __typename?: 'Mutation', deleteLabUser?: { __typename?: 'DeleteLabUser', success: boolean } | null };

export type CreateClientCompanyUserMutationVariables = Exact<{
  input: CreateClientCompanyUserInput;
}>;


export type CreateClientCompanyUserMutation = { __typename?: 'Mutation', createClientCompanyUser?: { __typename?: 'CreateClientCompanyUser', user?: { __typename?: 'User', id: any, firstName: string, lastName: string, email: string } | null } | null };

export type DeleteClientCompanyUserMutationVariables = Exact<{
  input: DeleteClientCompanyUserInput;
}>;


export type DeleteClientCompanyUserMutation = { __typename?: 'Mutation', deleteClientCompanyUser?: { __typename?: 'DeleteClientCompanyUser', success: boolean } | null };

export type SendAccountInvitationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SendAccountInvitationMutation = { __typename?: 'Mutation', sendAccountInvitation?: { __typename?: 'SendAccountInvitation', user?: { __typename?: 'User', id: any, firstName: string, lastName: string, email: string } | null } | null };

export type CreateClientCompanyMutationVariables = Exact<{
  input: CreateClientCompanyInput;
}>;


export type CreateClientCompanyMutation = { __typename?: 'Mutation', createClientCompany?: { __typename?: 'CreateClientCompany', clientCompany?: { __typename?: 'ClientCompany', id: any, businessName: string, addressStreet: string, addressCity: string, addressState: string, addressZip: string, phone: string, billingEmail: string, addressStreet2: string, paymentTerms: ClientCompanyPaymentTerms, easypostAddressId: string } | null } | null };

export type CreateLabClientNoteMutationVariables = Exact<{
  input: CreateLabClientNoteInput;
}>;


export type CreateLabClientNoteMutation = { __typename?: 'Mutation', createLabClientNote?: { __typename?: 'CreateLabClientNote', note?: { __typename?: 'LabClientNote', id: string, content: string, createdAt: any, createdBy?: { __typename?: 'User', id: any, firstName: string, lastName: string } | null } | null } | null };

export type UpdateClientCompanyMutationVariables = Exact<{
  input: UpdateClientCompanyInput;
}>;


export type UpdateClientCompanyMutation = { __typename?: 'Mutation', updateClientCompany?: { __typename?: 'UpdateClientCompany', clientCompany?: { __typename?: 'ClientCompany', id: any, businessName: string, addressStreet: string, addressCity: string, addressState: string, addressZip: string, phone: string, billingEmail: string, addressStreet2: string, paymentTerms: ClientCompanyPaymentTerms, easypostAddressId: string } | null } | null };

export type UpdateClientCompanyInternalMutationVariables = Exact<{
  input: UpdateClientCompanyInternalInput;
}>;


export type UpdateClientCompanyInternalMutation = { __typename?: 'Mutation', updateClientCompanyInternal?: { __typename?: 'UpdateClientCompanyInternal', clientCompany?: { __typename?: 'ClientCompanyInternal', id: any, cultivationStyle?: ClientCompanyCultivationStyle | null, paymentTerms: ClientCompanyPaymentTerms, numDaysMother?: number | null, numDaysPropagation?: number | null, numDaysVeg?: number | null, numDaysFlower?: number | null, numDaysHarvest?: number | null, harvestsPerYear?: number | null, motherRooms?: number | null, vegRooms?: number | null, flowerRooms?: number | null, propagationRooms?: number | null, roWaterFiltration?: boolean | null, sourceCuttings?: ClientCompanySourceCuttings | null, sourceTrim?: ClientCompanySourceTrim | null, dataTracking?: string | null, growingMedia?: ClientCompanyGrowingMedia | null, containerSize?: string | null, nutrientLine?: string | null, facilitySize?: string | null, numLights?: number | null, numSites?: number | null, potSizeGallon?: ClientCompanyPotSizeGallon | null, marketDestination?: ClientCompanyMarketDestination | null, waterSource?: ClientCompanyWaterSource | null, geneticsSource?: ClientCompanyGeneticsSource | null, lightingType?: ClientCompanyLightingType | null, numStrains?: number | null, numFlagshipStrains?: number | null, irrigationStyle?: ClientCompanyIrrigationStyle | null, irrigationFrequency?: ClientCompanyIrrigationFrequency | null, fertigationSystem?: string | null, flushBeforeHarvest?: boolean | null, daysOfFlushBeforeHarvest?: number | null, runoffVolume?: ClientCompanyRunoffVolume | null, environmentalControlSystem?: string | null, issueYield?: boolean | null, issueQuality?: boolean | null, issueConsistency?: boolean | null, issuePests?: boolean | null, issuePathogens?: boolean | null, issueBudSize?: boolean | null, issueWater?: boolean | null, issueEnvironmental?: boolean | null, issueCosts?: boolean | null, issuePlantNutrition?: boolean | null, issueStaffing?: boolean | null, goalYield?: boolean | null, goalQuality?: boolean | null, goalConsistency?: boolean | null, additiveBacterias?: boolean | null, additiveEnzymes?: boolean | null, additiveCarbohydrates?: boolean | null, additiveKelpExtract?: boolean | null, additiveSilica?: boolean | null, additiveBloomBooster?: boolean | null, additiveFlowerHardener?: boolean | null, additiveTerpeneEnhancer?: boolean | null, additivePotencyEnhancer?: boolean | null, additiveColorEnhancer?: boolean | null, additiveNutritional?: boolean | null, sensorTemp?: boolean | null, sensorHumidity?: boolean | null, sensorCo2?: boolean | null, sensorLight?: boolean | null, sensorSubstrate?: boolean | null, sensorVpd?: boolean | null, notes: Array<{ __typename?: 'LabClientNote', id: string, content: string, createdAt: any, createdBy?: { __typename?: 'User', id: any, firstName: string, lastName: string } | null }> } | null } | null };

export type UpdateClientCompanyPricingMutationVariables = Exact<{
  input: UpdateClientCompanyPricingInput;
}>;


export type UpdateClientCompanyPricingMutation = { __typename?: 'Mutation', updateClientCompanyPricing?: { __typename?: 'UpdateClientCompanyPricing', clientCompany?: { __typename?: 'ClientCompany', id: any, businessName: string, addressStreet: string, addressCity: string, addressState: string, addressZip: string, phone: string, billingEmail: string, addressStreet2: string, paymentTerms: ClientCompanyPaymentTerms, easypostAddressId: string, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null } | null } | null };

export type SendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendPasswordResetEmailMutation = { __typename?: 'Mutation', sendPasswordResetEmail?: { __typename?: 'Error', message: string } | { __typename?: 'SendPasswordResetEmailSuccess', success?: boolean | null } | null };

export type VerifyAddressMutationVariables = Exact<{
  input: VerifyAddressInput;
}>;


export type VerifyAddressMutation = { __typename?: 'Mutation', verifyAddress?: { __typename?: 'VerifyAddress', success: boolean, errors: Array<{ __typename?: 'VerifyAddressError', code: string, field?: string | null, message: string, suggestion?: string | null }> } | null };

export type PasswordResetMutationVariables = Exact<{
  token: Scalars['String'];
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', passwordReset?: { __typename?: 'Error', message: string } | { __typename?: 'PasswordResetSuccess', success?: boolean | null } | null };

export type RegisterUserAndClientCompanyMutationVariables = Exact<{
  input: RegisterUserAndClientCompanyInput;
}>;


export type RegisterUserAndClientCompanyMutation = { __typename?: 'Mutation', registerUserAndClientCompany?: { __typename?: 'RegisterUserAndClientCompany', success?: boolean | null, errors?: Array<string | null> | null, token?: string | null, refreshToken?: string | null } | null };

export type TokenAuthMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type TokenAuthMutation = { __typename?: 'Mutation', tokenAuth?: { __typename?: 'Error', message: string } | { __typename?: 'TokenAuthSuccess', token?: string | null, refreshToken?: string | null, user?: { __typename?: 'User', id: any, isStaff: boolean, email: string, firstName: string, lastName: string, businessName: string, phone: string, trackingColumnsEnabled?: Array<string | null> | null, notificationsEnabled: any, trackingColumnsAvailable?: Array<string | null> | null, mostRecentSampleUpdates?: any | null, clientCompany?: { __typename?: 'ClientCompany', id: any, businessName: string, addressStreet: string, addressCity: string, addressState: string, addressZip: string, phone: string, billingEmail: string, addressStreet2: string, paymentTerms: ClientCompanyPaymentTerms, easypostAddressId: string, laboratory: { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> } } | null, staffAtLaboratory?: { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> } | null } | null } | null };

export type UpdateTrackingColumnMutationVariables = Exact<{
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
}>;


export type UpdateTrackingColumnMutation = { __typename?: 'Mutation', updateTrackingColumn?: { __typename?: 'UpdateTrackingColumn', user?: { __typename?: 'User', trackingColumnsEnabled?: Array<string | null> | null, trackingColumnsAvailable?: Array<string | null> | null } | null } | null };

export type UpdateNotificationEnabledMutationVariables = Exact<{
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
}>;


export type UpdateNotificationEnabledMutation = { __typename?: 'Mutation', updateNotificationEnabled?: { __typename?: 'UpdateNotificationEnabled', user?: { __typename?: 'User', notificationsEnabled: any } | null } | null };

export type CreateHealthProfileMutationVariables = Exact<{
  input: CreateHealthProfileInput;
}>;


export type CreateHealthProfileMutation = { __typename?: 'Mutation', createHealthProfile?: { __typename?: 'CreateHealthProfile', healthProfile?: { __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> } | null } | null };

export type UpdateHealthProfileMutationVariables = Exact<{
  input: UpdateHealthProfileInput;
}>;


export type UpdateHealthProfileMutation = { __typename?: 'Mutation', updateHealthProfile?: { __typename?: 'UpdateHealthProfile', healthProfile?: { __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> } | null } | null };

export type ArchiveHealthProfileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveHealthProfileMutation = { __typename?: 'Mutation', archiveHealthProfile?: { __typename?: 'ArchiveHealthProfile', healthProfile?: { __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> } | null } | null };

export type UnarchiveHealthProfileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnarchiveHealthProfileMutation = { __typename?: 'Mutation', unarchiveHealthProfile?: { __typename?: 'UnarchiveHealthProfile', healthProfile?: { __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> } | null } | null };

export type ProfileFieldsFragment = { __typename?: 'User', id: any, isStaff: boolean, email: string, firstName: string, lastName: string, businessName: string, phone: string, trackingColumnsEnabled?: Array<string | null> | null, notificationsEnabled: any, trackingColumnsAvailable?: Array<string | null> | null, mostRecentSampleUpdates?: any | null, clientCompany?: { __typename?: 'ClientCompany', id: any, businessName: string, addressStreet: string, addressCity: string, addressState: string, addressZip: string, phone: string, billingEmail: string, addressStreet2: string, paymentTerms: ClientCompanyPaymentTerms, easypostAddressId: string, laboratory: { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> } } | null, staffAtLaboratory?: { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> } | null };

export type TrackingColumnsHistoriesFragment = { __typename?: 'User', id: any, trackingColumnsHistories?: Array<{ __typename?: 'TrackingColumnHistory', name: string, history: Array<string | null> } | null> | null };

export type ClientCompanyFieldsFragment = { __typename?: 'ClientCompany', id: any, businessName: string, addressStreet: string, addressCity: string, addressState: string, addressZip: string, phone: string, billingEmail: string, addressStreet2: string, paymentTerms: ClientCompanyPaymentTerms, easypostAddressId: string };

export type ClientCompanyInternalFragment = { __typename?: 'ClientCompanyInternal', id: any, cultivationStyle?: ClientCompanyCultivationStyle | null, paymentTerms: ClientCompanyPaymentTerms, numDaysMother?: number | null, numDaysPropagation?: number | null, numDaysVeg?: number | null, numDaysFlower?: number | null, numDaysHarvest?: number | null, harvestsPerYear?: number | null, motherRooms?: number | null, vegRooms?: number | null, flowerRooms?: number | null, propagationRooms?: number | null, roWaterFiltration?: boolean | null, sourceCuttings?: ClientCompanySourceCuttings | null, sourceTrim?: ClientCompanySourceTrim | null, dataTracking?: string | null, growingMedia?: ClientCompanyGrowingMedia | null, containerSize?: string | null, nutrientLine?: string | null, facilitySize?: string | null, numLights?: number | null, numSites?: number | null, potSizeGallon?: ClientCompanyPotSizeGallon | null, marketDestination?: ClientCompanyMarketDestination | null, waterSource?: ClientCompanyWaterSource | null, geneticsSource?: ClientCompanyGeneticsSource | null, lightingType?: ClientCompanyLightingType | null, numStrains?: number | null, numFlagshipStrains?: number | null, irrigationStyle?: ClientCompanyIrrigationStyle | null, irrigationFrequency?: ClientCompanyIrrigationFrequency | null, fertigationSystem?: string | null, flushBeforeHarvest?: boolean | null, daysOfFlushBeforeHarvest?: number | null, runoffVolume?: ClientCompanyRunoffVolume | null, environmentalControlSystem?: string | null, issueYield?: boolean | null, issueQuality?: boolean | null, issueConsistency?: boolean | null, issuePests?: boolean | null, issuePathogens?: boolean | null, issueBudSize?: boolean | null, issueWater?: boolean | null, issueEnvironmental?: boolean | null, issueCosts?: boolean | null, issuePlantNutrition?: boolean | null, issueStaffing?: boolean | null, goalYield?: boolean | null, goalQuality?: boolean | null, goalConsistency?: boolean | null, additiveBacterias?: boolean | null, additiveEnzymes?: boolean | null, additiveCarbohydrates?: boolean | null, additiveKelpExtract?: boolean | null, additiveSilica?: boolean | null, additiveBloomBooster?: boolean | null, additiveFlowerHardener?: boolean | null, additiveTerpeneEnhancer?: boolean | null, additivePotencyEnhancer?: boolean | null, additiveColorEnhancer?: boolean | null, additiveNutritional?: boolean | null, sensorTemp?: boolean | null, sensorHumidity?: boolean | null, sensorCo2?: boolean | null, sensorLight?: boolean | null, sensorSubstrate?: boolean | null, sensorVpd?: boolean | null, notes: Array<{ __typename?: 'LabClientNote', id: string, content: string, createdAt: any, createdBy?: { __typename?: 'User', id: any, firstName: string, lastName: string } | null }> };

export type IssuesInternalFragment = { __typename?: 'ClientCompanyInternal', issueYield?: boolean | null, issueQuality?: boolean | null, issueConsistency?: boolean | null, issuePests?: boolean | null, issuePathogens?: boolean | null, issueBudSize?: boolean | null, issueWater?: boolean | null, issueEnvironmental?: boolean | null, issueCosts?: boolean | null, issuePlantNutrition?: boolean | null, issueStaffing?: boolean | null };

export type GoalsInternalFragment = { __typename?: 'ClientCompanyInternal', goalYield?: boolean | null, goalQuality?: boolean | null, goalConsistency?: boolean | null };

export type AdditivesInternalFragment = { __typename?: 'ClientCompanyInternal', additiveBacterias?: boolean | null, additiveEnzymes?: boolean | null, additiveCarbohydrates?: boolean | null, additiveKelpExtract?: boolean | null, additiveSilica?: boolean | null, additiveBloomBooster?: boolean | null, additiveFlowerHardener?: boolean | null, additiveTerpeneEnhancer?: boolean | null, additivePotencyEnhancer?: boolean | null, additiveColorEnhancer?: boolean | null, additiveNutritional?: boolean | null };

export type SensorsInternalFragment = { __typename?: 'ClientCompanyInternal', sensorTemp?: boolean | null, sensorHumidity?: boolean | null, sensorCo2?: boolean | null, sensorLight?: boolean | null, sensorSubstrate?: boolean | null, sensorVpd?: boolean | null };

export type LabClientNoteFieldsFragment = { __typename?: 'LabClientNote', id: string, content: string, createdAt: any, createdBy?: { __typename?: 'User', id: any, firstName: string, lastName: string } | null };

export type ClientCompanyWithUsersFragment = { __typename?: 'ClientCompany', id: any, businessName: string, addressStreet: string, addressCity: string, addressState: string, addressZip: string, phone: string, billingEmail: string, addressStreet2: string, paymentTerms: ClientCompanyPaymentTerms, easypostAddressId: string, clientUsers: Array<{ __typename?: 'User', id: any, firstName: string, lastName: string, email: string }> };

export type ClientCompanyWithPricingFragment = { __typename?: 'ClientCompany', id: any, businessName: string, addressStreet: string, addressCity: string, addressState: string, addressZip: string, phone: string, billingEmail: string, addressStreet2: string, paymentTerms: ClientCompanyPaymentTerms, easypostAddressId: string, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null };

export type UserFieldsFragment = { __typename?: 'User', id: any, firstName: string, lastName: string, email: string };

export type LaboratoryFieldsFragment = { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> };

export type LaboratoryWithUsersFieldsFragment = { __typename?: 'Laboratory', id: any, businessName: string, customDomain: string, logoAsset?: string | null, accountRegistrationEnabled: boolean, checkoutEnabled: boolean, checkoutCustomerMustBuyShippingLabel: boolean, checkoutCustomerMustBuyReturnLabel: boolean, addressStreet: string, addressStreet2: string, addressCity: string, addressState: string, addressZip: string, phone: string, supportEmail: string, salesEmail: string, priceShippingUspsFirst?: number | null, priceShippingFedexOvernight?: number | null, freeShippingOver?: number | null, testTypesEnabled?: Array<string> | null, showTestPrices: boolean, priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null, staffUsers: Array<{ __typename?: 'User', id: any, firstName: string, lastName: string, email: string, staffAtLaboratory?: { __typename?: 'Laboratory', id: any } | null }>, healthProfiles: Array<{ __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> }> };

export type LabUserFieldsFragment = { __typename?: 'User', id: any, firstName: string, lastName: string, email: string, staffAtLaboratory?: { __typename?: 'Laboratory', id: any } | null };

export type LabTestPricesFragment = { __typename?: 'Laboratory', priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null };

export type CustomClientCompanyPricesFragment = { __typename?: 'ClientCompany', priceTestSoil?: number | null, priceTestPlantTissue?: number | null, priceTestFertilizer?: number | null, priceTestHopLatentViroid?: number | null, priceTestWater?: number | null, priceTestPythiumSpp?: number | null, priceTestRunOff?: number | null, priceTestNutrient?: number | null, priceTestHeavyMetal?: number | null, priceTestFusariumSpp?: number | null };

export type HealthProfileFragment = { __typename?: 'HealthProfile', id: any, title: string, testType: HealthProfileTestType, stage?: HealthProfileStage | null, cultivar?: string | null, archivedAt?: any | null, createdAt: any, lab: { __typename?: 'Laboratory', id: any, businessName: string }, analyteRanges: Array<{ __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number }> };

export type AnalyteHealthRangeFieldsFragment = { __typename?: 'AnalyteHealthRange', analyte: AnalyteHealthRangeAnalyte, min: number, low: number, high: number, max: number };

export const AnalyteInfoFragmentDoc = gql`
    fragment AnalyteInfo on AnalyteInfo {
  id
  label
  measurementUnit
  nicknames
  group
}
    `;
export const TestAnalytesFragmentDoc = gql`
    fragment TestAnalytes on TestAnalytes {
  testType
  analytes
}
    `;
export const ApplicationSettingsFragmentDoc = gql`
    fragment ApplicationSettings on ApplicationSettings {
  analytes {
    ...AnalyteInfo
  }
  testAnalytes {
    ...TestAnalytes
  }
}
    ${AnalyteInfoFragmentDoc}
${TestAnalytesFragmentDoc}`;
export const PagingInfoFragmentDoc = gql`
    fragment PagingInfo on PagingInfo {
  totalCount
  pageCount
  size
  start
  page
  hasNextPage
  hasPreviousPage
}
    `;
export const PricingFieldsFragmentDoc = gql`
    fragment PricingFields on OrderPricing {
  couponCode
  couponCodeValid
  couponDiscountDescription
  couponDiscountInCents
  numberOfSamples
  shippingTotalPriceInCents
  subtotalPriceInCents
  totalPriceInCents
  lineItems {
    product
    quantity
    pricePerUnitInCents
    totalInCents
  }
  shipToBuyer {
    method
    priceInCents
  }
  shipToLab {
    method
    priceInCents
  }
}
    `;
export const ShipmentSummaryFieldsFragmentDoc = gql`
    fragment ShipmentSummaryFields on Shipment {
  id
  carrier
  createdAt
  fromAddress
  toAddress
  labelUrl
  publicUrl
  trackingStatus
  trackingLatestDetail
  estimatedDelivery
}
    `;
export const OrderSummaryFieldsFragmentDoc = gql`
    fragment OrderSummaryFields on Order {
  id
  samplesOrdered
  orderDate
  couponClaimed
  totalPriceInCents
  paymentStatus
  processStatus
  pricingInfo {
    ...PricingFields
  }
  labelsUrl
  packingUrl
  shipmentToBuyer {
    ...ShipmentSummaryFields
  }
  shipmentToLab {
    ...ShipmentSummaryFields
  }
  clientCompany {
    businessName
    id
  }
}
    ${PricingFieldsFragmentDoc}
${ShipmentSummaryFieldsFragmentDoc}`;
export const SampleSummaryFieldsFragmentDoc = gql`
    fragment SampleSummaryFields on Sample {
  id
  status
  label
  group
  testType
  stage
  daysInStage
  location
  harvestGroup
  cultivar
  collectionDate
  healthProfileId
}
    `;
export const OrderWithSamplesFragmentDoc = gql`
    fragment OrderWithSamples on Order {
  ...OrderSummaryFields
  samples {
    ...SampleSummaryFields
  }
}
    ${OrderSummaryFieldsFragmentDoc}
${SampleSummaryFieldsFragmentDoc}`;
export const OrderPaginatedResultFragmentDoc = gql`
    fragment OrderPaginatedResult on OrderQuerysetResult {
  options {
    paging {
      ...PagingInfo
    }
    filters {
      search
    }
  }
  items {
    ...OrderWithSamples
  }
}
    ${PagingInfoFragmentDoc}
${OrderWithSamplesFragmentDoc}`;
export const CouponCodeFieldsFragmentDoc = gql`
    fragment CouponCodeFields on CouponCode {
  id
  code
  enabled
  publicAutomatic
  kind
  value
  minimumOrderPriceInCents
  maxOrdersPerUser
  maxSamplesPerUser
  validUntil
  discountAppliesToShippingCosts
  freeShippingCostUpToPriceInCents
  claimedCount
}
    `;
export const SampleResultFieldsFragmentDoc = gql`
    fragment SampleResultFields on Sample {
  id
  resultNitrogen
  resultPotassium
  resultPhosphorus
  resultSulfur
  resultCalcium
  resultMagnesium
  resultManganese
  resultIron
  resultMolybdenum
  resultCopper
  resultBoron
  resultZinc
  resultAluminum
  resultSodium
  resultPh
  resultEc
  resultSar
  resultCecEstimation
  resultTds
  resultAmmoniumNitrogen
  resultNitrateNitrogen
  resultPhosphorusPentoxide
  resultPotassiumOxide
  resultArsenic
  resultCadmium
  resultLead
  resultMercury
  resultHopLatentViroid
  resultFusariumSpp
  resultPythiumSpp
}
    `;
export const SingleAnalyteGroupReportFieldsFragmentDoc = gql`
    fragment SingleAnalyteGroupReportFields on ReportingSingleAnalyteGroupsOutput {
  analyte
  groupingColumn
  samples {
    ...SampleSummaryFields
    ...SampleResultFields
  }
  title
  keys
  dates
  points {
    values
    date
  }
}
    ${SampleSummaryFieldsFragmentDoc}
${SampleResultFieldsFragmentDoc}`;
export const LabSamplesFieldsFragmentDoc = gql`
    fragment LabSamplesFields on Sample {
  ...SampleSummaryFields
  order {
    id
    orderDate
    clientCompany {
      id
      businessName
    }
  }
}
    ${SampleSummaryFieldsFragmentDoc}`;
export const SampleFullFieldsFragmentDoc = gql`
    fragment SampleFullFields on Sample {
  ...SampleSummaryFields
  ...SampleResultFields
}
    ${SampleSummaryFieldsFragmentDoc}
${SampleResultFieldsFragmentDoc}`;
export const TestResultImportFieldsFragmentDoc = gql`
    fragment TestResultImportFields on TestResultImport {
  id
  createdAt
  importedBy {
    id
    email
    firstName
    lastName
  }
  filename
  testType
  fileUrl
}
    `;
export const ClientCompanyFieldsFragmentDoc = gql`
    fragment ClientCompanyFields on ClientCompany {
  id
  businessName
  addressStreet
  addressCity
  addressState
  addressZip
  phone
  billingEmail
  addressStreet2
  paymentTerms
  easypostAddressId
}
    `;
export const AnalyteHealthRangeFieldsFragmentDoc = gql`
    fragment AnalyteHealthRangeFields on AnalyteHealthRange {
  analyte
  min
  low
  high
  max
}
    `;
export const HealthProfileFragmentDoc = gql`
    fragment HealthProfile on HealthProfile {
  id
  title
  lab {
    id
    businessName
  }
  testType
  stage
  cultivar
  analyteRanges {
    ...AnalyteHealthRangeFields
  }
  archivedAt
  createdAt
}
    ${AnalyteHealthRangeFieldsFragmentDoc}`;
export const LabTestPricesFragmentDoc = gql`
    fragment LabTestPrices on Laboratory {
  priceTestSoil
  priceTestPlantTissue
  priceTestFertilizer
  priceTestHopLatentViroid
  priceTestWater
  priceTestPythiumSpp
  priceTestRunOff
  priceTestNutrient
  priceTestHeavyMetal
  priceTestFusariumSpp
}
    `;
export const LaboratoryFieldsFragmentDoc = gql`
    fragment LaboratoryFields on Laboratory {
  id
  businessName
  customDomain
  logoAsset
  accountRegistrationEnabled
  checkoutEnabled
  checkoutCustomerMustBuyShippingLabel
  checkoutCustomerMustBuyReturnLabel
  addressStreet
  addressStreet2
  addressCity
  addressState
  addressZip
  phone
  supportEmail
  salesEmail
  priceShippingUspsFirst
  priceShippingFedexOvernight
  freeShippingOver
  testTypesEnabled
  healthProfiles {
    ...HealthProfile
  }
  ...LabTestPrices
  showTestPrices
}
    ${HealthProfileFragmentDoc}
${LabTestPricesFragmentDoc}`;
export const ProfileFieldsFragmentDoc = gql`
    fragment ProfileFields on User {
  id
  isStaff
  clientCompany {
    ...ClientCompanyFields
    laboratory {
      ...LaboratoryFields
    }
  }
  staffAtLaboratory {
    ...LaboratoryFields
  }
  email
  firstName
  lastName
  businessName
  phone
  trackingColumnsEnabled
  notificationsEnabled
  trackingColumnsAvailable
  mostRecentSampleUpdates
}
    ${ClientCompanyFieldsFragmentDoc}
${LaboratoryFieldsFragmentDoc}`;
export const TrackingColumnsHistoriesFragmentDoc = gql`
    fragment TrackingColumnsHistories on User {
  id
  trackingColumnsHistories {
    name
    history
  }
}
    `;
export const IssuesInternalFragmentDoc = gql`
    fragment IssuesInternal on ClientCompanyInternal {
  issueYield
  issueQuality
  issueConsistency
  issuePests
  issuePathogens
  issueBudSize
  issueWater
  issueEnvironmental
  issueCosts
  issuePlantNutrition
  issueStaffing
}
    `;
export const GoalsInternalFragmentDoc = gql`
    fragment GoalsInternal on ClientCompanyInternal {
  goalYield
  goalQuality
  goalConsistency
}
    `;
export const AdditivesInternalFragmentDoc = gql`
    fragment AdditivesInternal on ClientCompanyInternal {
  additiveBacterias
  additiveEnzymes
  additiveCarbohydrates
  additiveKelpExtract
  additiveSilica
  additiveBloomBooster
  additiveFlowerHardener
  additiveTerpeneEnhancer
  additivePotencyEnhancer
  additiveColorEnhancer
  additiveNutritional
}
    `;
export const SensorsInternalFragmentDoc = gql`
    fragment SensorsInternal on ClientCompanyInternal {
  sensorTemp
  sensorHumidity
  sensorCo2
  sensorLight
  sensorSubstrate
  sensorVpd
}
    `;
export const LabClientNoteFieldsFragmentDoc = gql`
    fragment LabClientNoteFields on LabClientNote {
  id
  content
  createdBy {
    id
    firstName
    lastName
  }
  createdAt
}
    `;
export const ClientCompanyInternalFragmentDoc = gql`
    fragment ClientCompanyInternal on ClientCompanyInternal {
  id
  cultivationStyle
  paymentTerms
  numDaysMother
  numDaysPropagation
  numDaysVeg
  numDaysFlower
  numDaysHarvest
  harvestsPerYear
  motherRooms
  vegRooms
  flowerRooms
  propagationRooms
  roWaterFiltration
  sourceCuttings
  sourceTrim
  dataTracking
  growingMedia
  containerSize
  nutrientLine
  facilitySize
  numLights
  numSites
  ...IssuesInternal
  ...GoalsInternal
  ...AdditivesInternal
  ...SensorsInternal
  potSizeGallon
  marketDestination
  waterSource
  geneticsSource
  lightingType
  numStrains
  numFlagshipStrains
  irrigationStyle
  irrigationFrequency
  fertigationSystem
  flushBeforeHarvest
  daysOfFlushBeforeHarvest
  runoffVolume
  environmentalControlSystem
  notes {
    ...LabClientNoteFields
  }
}
    ${IssuesInternalFragmentDoc}
${GoalsInternalFragmentDoc}
${AdditivesInternalFragmentDoc}
${SensorsInternalFragmentDoc}
${LabClientNoteFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  firstName
  lastName
  email
}
    `;
export const ClientCompanyWithUsersFragmentDoc = gql`
    fragment ClientCompanyWithUsers on ClientCompany {
  ...ClientCompanyFields
  clientUsers {
    ...UserFields
  }
}
    ${ClientCompanyFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;
export const CustomClientCompanyPricesFragmentDoc = gql`
    fragment CustomClientCompanyPrices on ClientCompany {
  priceTestSoil
  priceTestPlantTissue
  priceTestFertilizer
  priceTestHopLatentViroid
  priceTestWater
  priceTestPythiumSpp
  priceTestRunOff
  priceTestNutrient
  priceTestHeavyMetal
  priceTestFusariumSpp
}
    `;
export const ClientCompanyWithPricingFragmentDoc = gql`
    fragment ClientCompanyWithPricing on ClientCompany {
  ...ClientCompanyFields
  ...CustomClientCompanyPrices
}
    ${ClientCompanyFieldsFragmentDoc}
${CustomClientCompanyPricesFragmentDoc}`;
export const LabUserFieldsFragmentDoc = gql`
    fragment LabUserFields on User {
  ...UserFields
  staffAtLaboratory {
    id
  }
}
    ${UserFieldsFragmentDoc}`;
export const LaboratoryWithUsersFieldsFragmentDoc = gql`
    fragment LaboratoryWithUsersFields on Laboratory {
  ...LaboratoryFields
  staffUsers {
    ...LabUserFields
  }
}
    ${LaboratoryFieldsFragmentDoc}
${LabUserFieldsFragmentDoc}`;
export const GetApplicationSettingsDocument = gql`
    query getApplicationSettings {
  getApplicationSettings {
    ...ApplicationSettings
  }
}
    ${ApplicationSettingsFragmentDoc}`;

/**
 * __useGetApplicationSettingsQuery__
 *
 * To run a query within a React component, call `useGetApplicationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApplicationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetApplicationSettingsQuery, GetApplicationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationSettingsQuery, GetApplicationSettingsQueryVariables>(GetApplicationSettingsDocument, options);
      }
export function useGetApplicationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationSettingsQuery, GetApplicationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationSettingsQuery, GetApplicationSettingsQueryVariables>(GetApplicationSettingsDocument, options);
        }
export type GetApplicationSettingsQueryHookResult = ReturnType<typeof useGetApplicationSettingsQuery>;
export type GetApplicationSettingsLazyQueryHookResult = ReturnType<typeof useGetApplicationSettingsLazyQuery>;
export type GetApplicationSettingsQueryResult = Apollo.QueryResult<GetApplicationSettingsQuery, GetApplicationSettingsQueryVariables>;
export const GetSiteLabDocument = gql`
    query getSiteLab($domain: String) {
  getCurrentLaboratory(domain: $domain) {
    ...LaboratoryFields
  }
}
    ${LaboratoryFieldsFragmentDoc}`;

/**
 * __useGetSiteLabQuery__
 *
 * To run a query within a React component, call `useGetSiteLabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteLabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteLabQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetSiteLabQuery(baseOptions?: Apollo.QueryHookOptions<GetSiteLabQuery, GetSiteLabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteLabQuery, GetSiteLabQueryVariables>(GetSiteLabDocument, options);
      }
export function useGetSiteLabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteLabQuery, GetSiteLabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteLabQuery, GetSiteLabQueryVariables>(GetSiteLabDocument, options);
        }
export type GetSiteLabQueryHookResult = ReturnType<typeof useGetSiteLabQuery>;
export type GetSiteLabLazyQueryHookResult = ReturnType<typeof useGetSiteLabLazyQuery>;
export type GetSiteLabQueryResult = Apollo.QueryResult<GetSiteLabQuery, GetSiteLabQueryVariables>;
export const QuoteCartDocument = gql`
    mutation quoteCart($input: QuoteCartInput) {
  quoteCart(input: $input) {
    pricing {
      ...PricingFields
    }
  }
}
    ${PricingFieldsFragmentDoc}`;
export type QuoteCartMutationFn = Apollo.MutationFunction<QuoteCartMutation, QuoteCartMutationVariables>;

/**
 * __useQuoteCartMutation__
 *
 * To run a mutation, you first call `useQuoteCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteCartMutation, { data, loading, error }] = useQuoteCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuoteCartMutation(baseOptions?: Apollo.MutationHookOptions<QuoteCartMutation, QuoteCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuoteCartMutation, QuoteCartMutationVariables>(QuoteCartDocument, options);
      }
export type QuoteCartMutationHookResult = ReturnType<typeof useQuoteCartMutation>;
export type QuoteCartMutationResult = Apollo.MutationResult<QuoteCartMutation>;
export type QuoteCartMutationOptions = Apollo.BaseMutationOptions<QuoteCartMutation, QuoteCartMutationVariables>;
export const PerformCheckoutDocument = gql`
    mutation performCheckout($input: PerformCheckoutInput) {
  performCheckout(input: $input) {
    paymentUrl
    order {
      ...OrderWithSamples
    }
    pricing {
      ...PricingFields
    }
  }
}
    ${OrderWithSamplesFragmentDoc}
${PricingFieldsFragmentDoc}`;
export type PerformCheckoutMutationFn = Apollo.MutationFunction<PerformCheckoutMutation, PerformCheckoutMutationVariables>;

/**
 * __usePerformCheckoutMutation__
 *
 * To run a mutation, you first call `usePerformCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePerformCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [performCheckoutMutation, { data, loading, error }] = usePerformCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePerformCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<PerformCheckoutMutation, PerformCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PerformCheckoutMutation, PerformCheckoutMutationVariables>(PerformCheckoutDocument, options);
      }
export type PerformCheckoutMutationHookResult = ReturnType<typeof usePerformCheckoutMutation>;
export type PerformCheckoutMutationResult = Apollo.MutationResult<PerformCheckoutMutation>;
export type PerformCheckoutMutationOptions = Apollo.BaseMutationOptions<PerformCheckoutMutation, PerformCheckoutMutationVariables>;
export const CreateDummyOrdersDocument = gql`
    mutation createDummyOrders($input: CreateDummyOrdersInput!) {
  createDummyOrders(input: $input) {
    orders {
      ...OrderWithSamples
    }
    createdOrders
    createdSamples
  }
}
    ${OrderWithSamplesFragmentDoc}`;
export type CreateDummyOrdersMutationFn = Apollo.MutationFunction<CreateDummyOrdersMutation, CreateDummyOrdersMutationVariables>;

/**
 * __useCreateDummyOrdersMutation__
 *
 * To run a mutation, you first call `useCreateDummyOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDummyOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDummyOrdersMutation, { data, loading, error }] = useCreateDummyOrdersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDummyOrdersMutation(baseOptions?: Apollo.MutationHookOptions<CreateDummyOrdersMutation, CreateDummyOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDummyOrdersMutation, CreateDummyOrdersMutationVariables>(CreateDummyOrdersDocument, options);
      }
export type CreateDummyOrdersMutationHookResult = ReturnType<typeof useCreateDummyOrdersMutation>;
export type CreateDummyOrdersMutationResult = Apollo.MutationResult<CreateDummyOrdersMutation>;
export type CreateDummyOrdersMutationOptions = Apollo.BaseMutationOptions<CreateDummyOrdersMutation, CreateDummyOrdersMutationVariables>;
export const CreateDummyResultsDocument = gql`
    mutation createDummyResults($input: CreateDummyResultsInput!) {
  createDummyResults(input: $input) {
    samples {
      ...SampleFullFields
    }
    updatedSamples
  }
}
    ${SampleFullFieldsFragmentDoc}`;
export type CreateDummyResultsMutationFn = Apollo.MutationFunction<CreateDummyResultsMutation, CreateDummyResultsMutationVariables>;

/**
 * __useCreateDummyResultsMutation__
 *
 * To run a mutation, you first call `useCreateDummyResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDummyResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDummyResultsMutation, { data, loading, error }] = useCreateDummyResultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDummyResultsMutation(baseOptions?: Apollo.MutationHookOptions<CreateDummyResultsMutation, CreateDummyResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDummyResultsMutation, CreateDummyResultsMutationVariables>(CreateDummyResultsDocument, options);
      }
export type CreateDummyResultsMutationHookResult = ReturnType<typeof useCreateDummyResultsMutation>;
export type CreateDummyResultsMutationResult = Apollo.MutationResult<CreateDummyResultsMutation>;
export type CreateDummyResultsMutationOptions = Apollo.BaseMutationOptions<CreateDummyResultsMutation, CreateDummyResultsMutationVariables>;
export const GetOrdersDocument = gql`
    query getOrders($options: OrderQuerysetOptionsInput) {
  getOrders(options: $options) {
    ...OrderPaginatedResult
  }
}
    ${OrderPaginatedResultFragmentDoc}`;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersQueryResult = Apollo.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetOrderDocument = gql`
    query getOrder($id: String!) {
  getOrder(id: $id) {
    ...OrderWithSamples
  }
}
    ${OrderWithSamplesFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<GetOrderQuery, GetOrderQueryVariables>;
export const GetCouponCodesDocument = gql`
    query getCouponCodes($filters: CouponCodeFilterSetInput) {
  getCouponCodes(filters: $filters) {
    ...CouponCodeFields
  }
}
    ${CouponCodeFieldsFragmentDoc}`;

/**
 * __useGetCouponCodesQuery__
 *
 * To run a query within a React component, call `useGetCouponCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouponCodesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCouponCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetCouponCodesQuery, GetCouponCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouponCodesQuery, GetCouponCodesQueryVariables>(GetCouponCodesDocument, options);
      }
export function useGetCouponCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouponCodesQuery, GetCouponCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouponCodesQuery, GetCouponCodesQueryVariables>(GetCouponCodesDocument, options);
        }
export type GetCouponCodesQueryHookResult = ReturnType<typeof useGetCouponCodesQuery>;
export type GetCouponCodesLazyQueryHookResult = ReturnType<typeof useGetCouponCodesLazyQuery>;
export type GetCouponCodesQueryResult = Apollo.QueryResult<GetCouponCodesQuery, GetCouponCodesQueryVariables>;
export const UpdateOrderProcessStatusDocument = gql`
    mutation updateOrderProcessStatus($input: UpdateOrderProcessStatusInput!) {
  updateOrderProcessStatus(input: $input) {
    order {
      ...OrderWithSamples
    }
  }
}
    ${OrderWithSamplesFragmentDoc}`;
export type UpdateOrderProcessStatusMutationFn = Apollo.MutationFunction<UpdateOrderProcessStatusMutation, UpdateOrderProcessStatusMutationVariables>;

/**
 * __useUpdateOrderProcessStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderProcessStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderProcessStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderProcessStatusMutation, { data, loading, error }] = useUpdateOrderProcessStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderProcessStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderProcessStatusMutation, UpdateOrderProcessStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderProcessStatusMutation, UpdateOrderProcessStatusMutationVariables>(UpdateOrderProcessStatusDocument, options);
      }
export type UpdateOrderProcessStatusMutationHookResult = ReturnType<typeof useUpdateOrderProcessStatusMutation>;
export type UpdateOrderProcessStatusMutationResult = Apollo.MutationResult<UpdateOrderProcessStatusMutation>;
export type UpdateOrderProcessStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderProcessStatusMutation, UpdateOrderProcessStatusMutationVariables>;
export const UpdateOrderPaymentStatusDocument = gql`
    mutation updateOrderPaymentStatus($input: UpdateOrderPaymentStatusInput!) {
  updateOrderPaymentStatus(input: $input) {
    order {
      ...OrderWithSamples
    }
  }
}
    ${OrderWithSamplesFragmentDoc}`;
export type UpdateOrderPaymentStatusMutationFn = Apollo.MutationFunction<UpdateOrderPaymentStatusMutation, UpdateOrderPaymentStatusMutationVariables>;

/**
 * __useUpdateOrderPaymentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderPaymentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderPaymentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderPaymentStatusMutation, { data, loading, error }] = useUpdateOrderPaymentStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderPaymentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderPaymentStatusMutation, UpdateOrderPaymentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderPaymentStatusMutation, UpdateOrderPaymentStatusMutationVariables>(UpdateOrderPaymentStatusDocument, options);
      }
export type UpdateOrderPaymentStatusMutationHookResult = ReturnType<typeof useUpdateOrderPaymentStatusMutation>;
export type UpdateOrderPaymentStatusMutationResult = Apollo.MutationResult<UpdateOrderPaymentStatusMutation>;
export type UpdateOrderPaymentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderPaymentStatusMutation, UpdateOrderPaymentStatusMutationVariables>;
export const CreateCouponCodeDocument = gql`
    mutation createCouponCode($input: CouponCodeInput!) {
  createCouponCode(input: $input) {
    couponCode {
      ...CouponCodeFields
    }
  }
}
    ${CouponCodeFieldsFragmentDoc}`;
export type CreateCouponCodeMutationFn = Apollo.MutationFunction<CreateCouponCodeMutation, CreateCouponCodeMutationVariables>;

/**
 * __useCreateCouponCodeMutation__
 *
 * To run a mutation, you first call `useCreateCouponCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCouponCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCouponCodeMutation, { data, loading, error }] = useCreateCouponCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCouponCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCouponCodeMutation, CreateCouponCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCouponCodeMutation, CreateCouponCodeMutationVariables>(CreateCouponCodeDocument, options);
      }
export type CreateCouponCodeMutationHookResult = ReturnType<typeof useCreateCouponCodeMutation>;
export type CreateCouponCodeMutationResult = Apollo.MutationResult<CreateCouponCodeMutation>;
export type CreateCouponCodeMutationOptions = Apollo.BaseMutationOptions<CreateCouponCodeMutation, CreateCouponCodeMutationVariables>;
export const EditCouponCodeDocument = gql`
    mutation editCouponCode($input: EditCouponCodeInput!) {
  editCouponCode(input: $input) {
    couponCode {
      ...CouponCodeFields
    }
  }
}
    ${CouponCodeFieldsFragmentDoc}`;
export type EditCouponCodeMutationFn = Apollo.MutationFunction<EditCouponCodeMutation, EditCouponCodeMutationVariables>;

/**
 * __useEditCouponCodeMutation__
 *
 * To run a mutation, you first call `useEditCouponCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCouponCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCouponCodeMutation, { data, loading, error }] = useEditCouponCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCouponCodeMutation(baseOptions?: Apollo.MutationHookOptions<EditCouponCodeMutation, EditCouponCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCouponCodeMutation, EditCouponCodeMutationVariables>(EditCouponCodeDocument, options);
      }
export type EditCouponCodeMutationHookResult = ReturnType<typeof useEditCouponCodeMutation>;
export type EditCouponCodeMutationResult = Apollo.MutationResult<EditCouponCodeMutation>;
export type EditCouponCodeMutationOptions = Apollo.BaseMutationOptions<EditCouponCodeMutation, EditCouponCodeMutationVariables>;
export const EditOrderDocument = gql`
    mutation editOrder($input: EditOrderInput!) {
  editOrder(input: $input) {
    order {
      ...OrderWithSamples
    }
  }
}
    ${OrderWithSamplesFragmentDoc}`;
export type EditOrderMutationFn = Apollo.MutationFunction<EditOrderMutation, EditOrderMutationVariables>;

/**
 * __useEditOrderMutation__
 *
 * To run a mutation, you first call `useEditOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrderMutation, { data, loading, error }] = useEditOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditOrderMutation(baseOptions?: Apollo.MutationHookOptions<EditOrderMutation, EditOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrderMutation, EditOrderMutationVariables>(EditOrderDocument, options);
      }
export type EditOrderMutationHookResult = ReturnType<typeof useEditOrderMutation>;
export type EditOrderMutationResult = Apollo.MutationResult<EditOrderMutation>;
export type EditOrderMutationOptions = Apollo.BaseMutationOptions<EditOrderMutation, EditOrderMutationVariables>;
export const SingleAnalyteGroupReportsDocument = gql`
    query singleAnalyteGroupReports($groupingColumn: String!, $analyte: String!, $xAxis: String!, $filters: SampleFilterSetInput) {
  singleAnalyteGroupReports(
    groupingColumn: $groupingColumn
    analyte: $analyte
    xAxis: $xAxis
    filters: $filters
  ) {
    ...SingleAnalyteGroupReportFields
  }
}
    ${SingleAnalyteGroupReportFieldsFragmentDoc}`;

/**
 * __useSingleAnalyteGroupReportsQuery__
 *
 * To run a query within a React component, call `useSingleAnalyteGroupReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAnalyteGroupReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAnalyteGroupReportsQuery({
 *   variables: {
 *      groupingColumn: // value for 'groupingColumn'
 *      analyte: // value for 'analyte'
 *      xAxis: // value for 'xAxis'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSingleAnalyteGroupReportsQuery(baseOptions: Apollo.QueryHookOptions<SingleAnalyteGroupReportsQuery, SingleAnalyteGroupReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAnalyteGroupReportsQuery, SingleAnalyteGroupReportsQueryVariables>(SingleAnalyteGroupReportsDocument, options);
      }
export function useSingleAnalyteGroupReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAnalyteGroupReportsQuery, SingleAnalyteGroupReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAnalyteGroupReportsQuery, SingleAnalyteGroupReportsQueryVariables>(SingleAnalyteGroupReportsDocument, options);
        }
export type SingleAnalyteGroupReportsQueryHookResult = ReturnType<typeof useSingleAnalyteGroupReportsQuery>;
export type SingleAnalyteGroupReportsLazyQueryHookResult = ReturnType<typeof useSingleAnalyteGroupReportsLazyQuery>;
export type SingleAnalyteGroupReportsQueryResult = Apollo.QueryResult<SingleAnalyteGroupReportsQuery, SingleAnalyteGroupReportsQueryVariables>;
export const SampleFilterResultsDocument = gql`
    query sampleFilterResults($filters: SampleFilterSetInput!) {
  getSamples(filters: $filters) {
    ...SampleFullFields
  }
}
    ${SampleFullFieldsFragmentDoc}`;

/**
 * __useSampleFilterResultsQuery__
 *
 * To run a query within a React component, call `useSampleFilterResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSampleFilterResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSampleFilterResultsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSampleFilterResultsQuery(baseOptions: Apollo.QueryHookOptions<SampleFilterResultsQuery, SampleFilterResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SampleFilterResultsQuery, SampleFilterResultsQueryVariables>(SampleFilterResultsDocument, options);
      }
export function useSampleFilterResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SampleFilterResultsQuery, SampleFilterResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SampleFilterResultsQuery, SampleFilterResultsQueryVariables>(SampleFilterResultsDocument, options);
        }
export type SampleFilterResultsQueryHookResult = ReturnType<typeof useSampleFilterResultsQuery>;
export type SampleFilterResultsLazyQueryHookResult = ReturnType<typeof useSampleFilterResultsLazyQuery>;
export type SampleFilterResultsQueryResult = Apollo.QueryResult<SampleFilterResultsQuery, SampleFilterResultsQueryVariables>;
export const LabSamplesDocument = gql`
    query labSamples($filters: SampleFilterSetInput!) {
  getSamples(filters: $filters) {
    ...LabSamplesFields
  }
}
    ${LabSamplesFieldsFragmentDoc}`;

/**
 * __useLabSamplesQuery__
 *
 * To run a query within a React component, call `useLabSamplesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabSamplesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabSamplesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useLabSamplesQuery(baseOptions: Apollo.QueryHookOptions<LabSamplesQuery, LabSamplesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabSamplesQuery, LabSamplesQueryVariables>(LabSamplesDocument, options);
      }
export function useLabSamplesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabSamplesQuery, LabSamplesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabSamplesQuery, LabSamplesQueryVariables>(LabSamplesDocument, options);
        }
export type LabSamplesQueryHookResult = ReturnType<typeof useLabSamplesQuery>;
export type LabSamplesLazyQueryHookResult = ReturnType<typeof useLabSamplesLazyQuery>;
export type LabSamplesQueryResult = Apollo.QueryResult<LabSamplesQuery, LabSamplesQueryVariables>;
export const GetCompleteSamplesDocument = gql`
    query getCompleteSamples {
  getSamples(filters: {status: "COMPLETE"}) {
    ...SampleSummaryFields
    ...SampleResultFields
  }
}
    ${SampleSummaryFieldsFragmentDoc}
${SampleResultFieldsFragmentDoc}`;

/**
 * __useGetCompleteSamplesQuery__
 *
 * To run a query within a React component, call `useGetCompleteSamplesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompleteSamplesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompleteSamplesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompleteSamplesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompleteSamplesQuery, GetCompleteSamplesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompleteSamplesQuery, GetCompleteSamplesQueryVariables>(GetCompleteSamplesDocument, options);
      }
export function useGetCompleteSamplesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompleteSamplesQuery, GetCompleteSamplesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompleteSamplesQuery, GetCompleteSamplesQueryVariables>(GetCompleteSamplesDocument, options);
        }
export type GetCompleteSamplesQueryHookResult = ReturnType<typeof useGetCompleteSamplesQuery>;
export type GetCompleteSamplesLazyQueryHookResult = ReturnType<typeof useGetCompleteSamplesLazyQuery>;
export type GetCompleteSamplesQueryResult = Apollo.QueryResult<GetCompleteSamplesQuery, GetCompleteSamplesQueryVariables>;
export const GetSampleIdsDocument = gql`
    query getSampleIds($status: String) {
  getSamples(filters: {status: $status}) {
    id
  }
}
    `;

/**
 * __useGetSampleIdsQuery__
 *
 * To run a query within a React component, call `useGetSampleIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSampleIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSampleIdsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetSampleIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetSampleIdsQuery, GetSampleIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSampleIdsQuery, GetSampleIdsQueryVariables>(GetSampleIdsDocument, options);
      }
export function useGetSampleIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSampleIdsQuery, GetSampleIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSampleIdsQuery, GetSampleIdsQueryVariables>(GetSampleIdsDocument, options);
        }
export type GetSampleIdsQueryHookResult = ReturnType<typeof useGetSampleIdsQuery>;
export type GetSampleIdsLazyQueryHookResult = ReturnType<typeof useGetSampleIdsLazyQuery>;
export type GetSampleIdsQueryResult = Apollo.QueryResult<GetSampleIdsQuery, GetSampleIdsQueryVariables>;
export const UpdateSampleInfoDocument = gql`
    mutation updateSampleInfo($input: UpdateSampleInput!) {
  updateSampleInfo(input: $input) {
    sample {
      ...SampleSummaryFields
    }
  }
}
    ${SampleSummaryFieldsFragmentDoc}`;
export type UpdateSampleInfoMutationFn = Apollo.MutationFunction<UpdateSampleInfoMutation, UpdateSampleInfoMutationVariables>;

/**
 * __useUpdateSampleInfoMutation__
 *
 * To run a mutation, you first call `useUpdateSampleInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSampleInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSampleInfoMutation, { data, loading, error }] = useUpdateSampleInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSampleInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSampleInfoMutation, UpdateSampleInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSampleInfoMutation, UpdateSampleInfoMutationVariables>(UpdateSampleInfoDocument, options);
      }
export type UpdateSampleInfoMutationHookResult = ReturnType<typeof useUpdateSampleInfoMutation>;
export type UpdateSampleInfoMutationResult = Apollo.MutationResult<UpdateSampleInfoMutation>;
export type UpdateSampleInfoMutationOptions = Apollo.BaseMutationOptions<UpdateSampleInfoMutation, UpdateSampleInfoMutationVariables>;
export const UpdateSamplesInfoDocument = gql`
    mutation updateSamplesInfo($input: UpdateSamplesInput!) {
  updateSamplesInfo(input: $input) {
    samples {
      ...SampleSummaryFields
    }
  }
}
    ${SampleSummaryFieldsFragmentDoc}`;
export type UpdateSamplesInfoMutationFn = Apollo.MutationFunction<UpdateSamplesInfoMutation, UpdateSamplesInfoMutationVariables>;

/**
 * __useUpdateSamplesInfoMutation__
 *
 * To run a mutation, you first call `useUpdateSamplesInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSamplesInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSamplesInfoMutation, { data, loading, error }] = useUpdateSamplesInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSamplesInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSamplesInfoMutation, UpdateSamplesInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSamplesInfoMutation, UpdateSamplesInfoMutationVariables>(UpdateSamplesInfoDocument, options);
      }
export type UpdateSamplesInfoMutationHookResult = ReturnType<typeof useUpdateSamplesInfoMutation>;
export type UpdateSamplesInfoMutationResult = Apollo.MutationResult<UpdateSamplesInfoMutation>;
export type UpdateSamplesInfoMutationOptions = Apollo.BaseMutationOptions<UpdateSamplesInfoMutation, UpdateSamplesInfoMutationVariables>;
export const UpdateResultsDocument = gql`
    mutation updateResults($input: UpdateResultsInput!) {
  updateResults(input: $input) {
    updated {
      ...SampleSummaryFields
      ...SampleResultFields
    }
    errors
  }
}
    ${SampleSummaryFieldsFragmentDoc}
${SampleResultFieldsFragmentDoc}`;
export type UpdateResultsMutationFn = Apollo.MutationFunction<UpdateResultsMutation, UpdateResultsMutationVariables>;

/**
 * __useUpdateResultsMutation__
 *
 * To run a mutation, you first call `useUpdateResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResultsMutation, { data, loading, error }] = useUpdateResultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResultsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResultsMutation, UpdateResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResultsMutation, UpdateResultsMutationVariables>(UpdateResultsDocument, options);
      }
export type UpdateResultsMutationHookResult = ReturnType<typeof useUpdateResultsMutation>;
export type UpdateResultsMutationResult = Apollo.MutationResult<UpdateResultsMutation>;
export type UpdateResultsMutationOptions = Apollo.BaseMutationOptions<UpdateResultsMutation, UpdateResultsMutationVariables>;
export const GetTestResultImportsDocument = gql`
    query getTestResultImports {
  getTestResultImports {
    ...TestResultImportFields
  }
}
    ${TestResultImportFieldsFragmentDoc}`;

/**
 * __useGetTestResultImportsQuery__
 *
 * To run a query within a React component, call `useGetTestResultImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestResultImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTestResultImportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTestResultImportsQuery(baseOptions?: Apollo.QueryHookOptions<GetTestResultImportsQuery, GetTestResultImportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTestResultImportsQuery, GetTestResultImportsQueryVariables>(GetTestResultImportsDocument, options);
      }
export function useGetTestResultImportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTestResultImportsQuery, GetTestResultImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTestResultImportsQuery, GetTestResultImportsQueryVariables>(GetTestResultImportsDocument, options);
        }
export type GetTestResultImportsQueryHookResult = ReturnType<typeof useGetTestResultImportsQuery>;
export type GetTestResultImportsLazyQueryHookResult = ReturnType<typeof useGetTestResultImportsLazyQuery>;
export type GetTestResultImportsQueryResult = Apollo.QueryResult<GetTestResultImportsQuery, GetTestResultImportsQueryVariables>;
export const MyProfileDocument = gql`
    query myProfile {
  myProfile {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;

/**
 * __useMyProfileQuery__
 *
 * To run a query within a React component, call `useMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileQuery(baseOptions?: Apollo.QueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
      }
export function useMyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
        }
export type MyProfileQueryHookResult = ReturnType<typeof useMyProfileQuery>;
export type MyProfileLazyQueryHookResult = ReturnType<typeof useMyProfileLazyQuery>;
export type MyProfileQueryResult = Apollo.QueryResult<MyProfileQuery, MyProfileQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers($filters: UserFilterSetInput) {
  getUsers(filters: $filters) {
    ...ProfileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetClientCompaniesDocument = gql`
    query getClientCompanies($filters: ClientCompanyFilterSetInput) {
  getClientCompanies(filters: $filters) {
    ...ClientCompanyFields
    ...ClientCompanyWithPricing
  }
}
    ${ClientCompanyFieldsFragmentDoc}
${ClientCompanyWithPricingFragmentDoc}`;

/**
 * __useGetClientCompaniesQuery__
 *
 * To run a query within a React component, call `useGetClientCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCompaniesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetClientCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetClientCompaniesQuery, GetClientCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientCompaniesQuery, GetClientCompaniesQueryVariables>(GetClientCompaniesDocument, options);
      }
export function useGetClientCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientCompaniesQuery, GetClientCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientCompaniesQuery, GetClientCompaniesQueryVariables>(GetClientCompaniesDocument, options);
        }
export type GetClientCompaniesQueryHookResult = ReturnType<typeof useGetClientCompaniesQuery>;
export type GetClientCompaniesLazyQueryHookResult = ReturnType<typeof useGetClientCompaniesLazyQuery>;
export type GetClientCompaniesQueryResult = Apollo.QueryResult<GetClientCompaniesQuery, GetClientCompaniesQueryVariables>;
export const GetClientCompanyDocument = gql`
    query getClientCompany($id: String!) {
  getClientCompany(id: $id) {
    ...ClientCompanyWithUsers
    ...ClientCompanyWithPricing
  }
}
    ${ClientCompanyWithUsersFragmentDoc}
${ClientCompanyWithPricingFragmentDoc}`;

/**
 * __useGetClientCompanyQuery__
 *
 * To run a query within a React component, call `useGetClientCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetClientCompanyQuery, GetClientCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientCompanyQuery, GetClientCompanyQueryVariables>(GetClientCompanyDocument, options);
      }
export function useGetClientCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientCompanyQuery, GetClientCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientCompanyQuery, GetClientCompanyQueryVariables>(GetClientCompanyDocument, options);
        }
export type GetClientCompanyQueryHookResult = ReturnType<typeof useGetClientCompanyQuery>;
export type GetClientCompanyLazyQueryHookResult = ReturnType<typeof useGetClientCompanyLazyQuery>;
export type GetClientCompanyQueryResult = Apollo.QueryResult<GetClientCompanyQuery, GetClientCompanyQueryVariables>;
export const GetClientCompanyInternalDocument = gql`
    query getClientCompanyInternal($id: String!) {
  getClientCompanyInternal(id: $id) {
    ...ClientCompanyInternal
  }
}
    ${ClientCompanyInternalFragmentDoc}`;

/**
 * __useGetClientCompanyInternalQuery__
 *
 * To run a query within a React component, call `useGetClientCompanyInternalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCompanyInternalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCompanyInternalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientCompanyInternalQuery(baseOptions: Apollo.QueryHookOptions<GetClientCompanyInternalQuery, GetClientCompanyInternalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientCompanyInternalQuery, GetClientCompanyInternalQueryVariables>(GetClientCompanyInternalDocument, options);
      }
export function useGetClientCompanyInternalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientCompanyInternalQuery, GetClientCompanyInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientCompanyInternalQuery, GetClientCompanyInternalQueryVariables>(GetClientCompanyInternalDocument, options);
        }
export type GetClientCompanyInternalQueryHookResult = ReturnType<typeof useGetClientCompanyInternalQuery>;
export type GetClientCompanyInternalLazyQueryHookResult = ReturnType<typeof useGetClientCompanyInternalLazyQuery>;
export type GetClientCompanyInternalQueryResult = Apollo.QueryResult<GetClientCompanyInternalQuery, GetClientCompanyInternalQueryVariables>;
export const GetLaboratoriesDocument = gql`
    query getLaboratories($filters: LaboratoryFilterSetInput) {
  getLaboratories(filters: $filters) {
    ...LaboratoryFields
  }
}
    ${LaboratoryFieldsFragmentDoc}`;

/**
 * __useGetLaboratoriesQuery__
 *
 * To run a query within a React component, call `useGetLaboratoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaboratoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaboratoriesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetLaboratoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetLaboratoriesQuery, GetLaboratoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaboratoriesQuery, GetLaboratoriesQueryVariables>(GetLaboratoriesDocument, options);
      }
export function useGetLaboratoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaboratoriesQuery, GetLaboratoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaboratoriesQuery, GetLaboratoriesQueryVariables>(GetLaboratoriesDocument, options);
        }
export type GetLaboratoriesQueryHookResult = ReturnType<typeof useGetLaboratoriesQuery>;
export type GetLaboratoriesLazyQueryHookResult = ReturnType<typeof useGetLaboratoriesLazyQuery>;
export type GetLaboratoriesQueryResult = Apollo.QueryResult<GetLaboratoriesQuery, GetLaboratoriesQueryVariables>;
export const GetLaboratoryDocument = gql`
    query getLaboratory($id: String!) {
  getLaboratory(id: $id) {
    ...LaboratoryWithUsersFields
  }
}
    ${LaboratoryWithUsersFieldsFragmentDoc}`;

/**
 * __useGetLaboratoryQuery__
 *
 * To run a query within a React component, call `useGetLaboratoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaboratoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaboratoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLaboratoryQuery(baseOptions: Apollo.QueryHookOptions<GetLaboratoryQuery, GetLaboratoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaboratoryQuery, GetLaboratoryQueryVariables>(GetLaboratoryDocument, options);
      }
export function useGetLaboratoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaboratoryQuery, GetLaboratoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaboratoryQuery, GetLaboratoryQueryVariables>(GetLaboratoryDocument, options);
        }
export type GetLaboratoryQueryHookResult = ReturnType<typeof useGetLaboratoryQuery>;
export type GetLaboratoryLazyQueryHookResult = ReturnType<typeof useGetLaboratoryLazyQuery>;
export type GetLaboratoryQueryResult = Apollo.QueryResult<GetLaboratoryQuery, GetLaboratoryQueryVariables>;
export const TrackingColumnsHistoriesDocument = gql`
    query trackingColumnsHistories {
  myProfile {
    ...TrackingColumnsHistories
  }
}
    ${TrackingColumnsHistoriesFragmentDoc}`;

/**
 * __useTrackingColumnsHistoriesQuery__
 *
 * To run a query within a React component, call `useTrackingColumnsHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackingColumnsHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackingColumnsHistoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrackingColumnsHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<TrackingColumnsHistoriesQuery, TrackingColumnsHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackingColumnsHistoriesQuery, TrackingColumnsHistoriesQueryVariables>(TrackingColumnsHistoriesDocument, options);
      }
export function useTrackingColumnsHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackingColumnsHistoriesQuery, TrackingColumnsHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackingColumnsHistoriesQuery, TrackingColumnsHistoriesQueryVariables>(TrackingColumnsHistoriesDocument, options);
        }
export type TrackingColumnsHistoriesQueryHookResult = ReturnType<typeof useTrackingColumnsHistoriesQuery>;
export type TrackingColumnsHistoriesLazyQueryHookResult = ReturnType<typeof useTrackingColumnsHistoriesLazyQuery>;
export type TrackingColumnsHistoriesQueryResult = Apollo.QueryResult<TrackingColumnsHistoriesQuery, TrackingColumnsHistoriesQueryVariables>;
export const UpdateLaboratoryDocument = gql`
    mutation updateLaboratory($input: UpdateLaboratoryInput!) {
  updateLaboratory(input: $input) {
    lab {
      ...LaboratoryFields
    }
  }
}
    ${LaboratoryFieldsFragmentDoc}`;
export type UpdateLaboratoryMutationFn = Apollo.MutationFunction<UpdateLaboratoryMutation, UpdateLaboratoryMutationVariables>;

/**
 * __useUpdateLaboratoryMutation__
 *
 * To run a mutation, you first call `useUpdateLaboratoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaboratoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaboratoryMutation, { data, loading, error }] = useUpdateLaboratoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLaboratoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLaboratoryMutation, UpdateLaboratoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLaboratoryMutation, UpdateLaboratoryMutationVariables>(UpdateLaboratoryDocument, options);
      }
export type UpdateLaboratoryMutationHookResult = ReturnType<typeof useUpdateLaboratoryMutation>;
export type UpdateLaboratoryMutationResult = Apollo.MutationResult<UpdateLaboratoryMutation>;
export type UpdateLaboratoryMutationOptions = Apollo.BaseMutationOptions<UpdateLaboratoryMutation, UpdateLaboratoryMutationVariables>;
export const CreateLabUserDocument = gql`
    mutation createLabUser($input: CreateLabUserInput!) {
  createLabUser(input: $input) {
    user {
      ...LabUserFields
    }
  }
}
    ${LabUserFieldsFragmentDoc}`;
export type CreateLabUserMutationFn = Apollo.MutationFunction<CreateLabUserMutation, CreateLabUserMutationVariables>;

/**
 * __useCreateLabUserMutation__
 *
 * To run a mutation, you first call `useCreateLabUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabUserMutation, { data, loading, error }] = useCreateLabUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLabUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateLabUserMutation, CreateLabUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLabUserMutation, CreateLabUserMutationVariables>(CreateLabUserDocument, options);
      }
export type CreateLabUserMutationHookResult = ReturnType<typeof useCreateLabUserMutation>;
export type CreateLabUserMutationResult = Apollo.MutationResult<CreateLabUserMutation>;
export type CreateLabUserMutationOptions = Apollo.BaseMutationOptions<CreateLabUserMutation, CreateLabUserMutationVariables>;
export const DeleteLabUserDocument = gql`
    mutation deleteLabUser($input: DeleteLabUserInput!) {
  deleteLabUser(input: $input) {
    success
  }
}
    `;
export type DeleteLabUserMutationFn = Apollo.MutationFunction<DeleteLabUserMutation, DeleteLabUserMutationVariables>;

/**
 * __useDeleteLabUserMutation__
 *
 * To run a mutation, you first call `useDeleteLabUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLabUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLabUserMutation, { data, loading, error }] = useDeleteLabUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLabUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLabUserMutation, DeleteLabUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLabUserMutation, DeleteLabUserMutationVariables>(DeleteLabUserDocument, options);
      }
export type DeleteLabUserMutationHookResult = ReturnType<typeof useDeleteLabUserMutation>;
export type DeleteLabUserMutationResult = Apollo.MutationResult<DeleteLabUserMutation>;
export type DeleteLabUserMutationOptions = Apollo.BaseMutationOptions<DeleteLabUserMutation, DeleteLabUserMutationVariables>;
export const CreateClientCompanyUserDocument = gql`
    mutation createClientCompanyUser($input: CreateClientCompanyUserInput!) {
  createClientCompanyUser(input: $input) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateClientCompanyUserMutationFn = Apollo.MutationFunction<CreateClientCompanyUserMutation, CreateClientCompanyUserMutationVariables>;

/**
 * __useCreateClientCompanyUserMutation__
 *
 * To run a mutation, you first call `useCreateClientCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientCompanyUserMutation, { data, loading, error }] = useCreateClientCompanyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientCompanyUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientCompanyUserMutation, CreateClientCompanyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientCompanyUserMutation, CreateClientCompanyUserMutationVariables>(CreateClientCompanyUserDocument, options);
      }
export type CreateClientCompanyUserMutationHookResult = ReturnType<typeof useCreateClientCompanyUserMutation>;
export type CreateClientCompanyUserMutationResult = Apollo.MutationResult<CreateClientCompanyUserMutation>;
export type CreateClientCompanyUserMutationOptions = Apollo.BaseMutationOptions<CreateClientCompanyUserMutation, CreateClientCompanyUserMutationVariables>;
export const DeleteClientCompanyUserDocument = gql`
    mutation deleteClientCompanyUser($input: DeleteClientCompanyUserInput!) {
  deleteClientCompanyUser(input: $input) {
    success
  }
}
    `;
export type DeleteClientCompanyUserMutationFn = Apollo.MutationFunction<DeleteClientCompanyUserMutation, DeleteClientCompanyUserMutationVariables>;

/**
 * __useDeleteClientCompanyUserMutation__
 *
 * To run a mutation, you first call `useDeleteClientCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientCompanyUserMutation, { data, loading, error }] = useDeleteClientCompanyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteClientCompanyUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientCompanyUserMutation, DeleteClientCompanyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientCompanyUserMutation, DeleteClientCompanyUserMutationVariables>(DeleteClientCompanyUserDocument, options);
      }
export type DeleteClientCompanyUserMutationHookResult = ReturnType<typeof useDeleteClientCompanyUserMutation>;
export type DeleteClientCompanyUserMutationResult = Apollo.MutationResult<DeleteClientCompanyUserMutation>;
export type DeleteClientCompanyUserMutationOptions = Apollo.BaseMutationOptions<DeleteClientCompanyUserMutation, DeleteClientCompanyUserMutationVariables>;
export const SendAccountInvitationDocument = gql`
    mutation sendAccountInvitation($id: ID!) {
  sendAccountInvitation(id: $id) {
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type SendAccountInvitationMutationFn = Apollo.MutationFunction<SendAccountInvitationMutation, SendAccountInvitationMutationVariables>;

/**
 * __useSendAccountInvitationMutation__
 *
 * To run a mutation, you first call `useSendAccountInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAccountInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAccountInvitationMutation, { data, loading, error }] = useSendAccountInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendAccountInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendAccountInvitationMutation, SendAccountInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAccountInvitationMutation, SendAccountInvitationMutationVariables>(SendAccountInvitationDocument, options);
      }
export type SendAccountInvitationMutationHookResult = ReturnType<typeof useSendAccountInvitationMutation>;
export type SendAccountInvitationMutationResult = Apollo.MutationResult<SendAccountInvitationMutation>;
export type SendAccountInvitationMutationOptions = Apollo.BaseMutationOptions<SendAccountInvitationMutation, SendAccountInvitationMutationVariables>;
export const CreateClientCompanyDocument = gql`
    mutation createClientCompany($input: CreateClientCompanyInput!) {
  createClientCompany(input: $input) {
    clientCompany {
      ...ClientCompanyFields
    }
  }
}
    ${ClientCompanyFieldsFragmentDoc}`;
export type CreateClientCompanyMutationFn = Apollo.MutationFunction<CreateClientCompanyMutation, CreateClientCompanyMutationVariables>;

/**
 * __useCreateClientCompanyMutation__
 *
 * To run a mutation, you first call `useCreateClientCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientCompanyMutation, { data, loading, error }] = useCreateClientCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientCompanyMutation, CreateClientCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientCompanyMutation, CreateClientCompanyMutationVariables>(CreateClientCompanyDocument, options);
      }
export type CreateClientCompanyMutationHookResult = ReturnType<typeof useCreateClientCompanyMutation>;
export type CreateClientCompanyMutationResult = Apollo.MutationResult<CreateClientCompanyMutation>;
export type CreateClientCompanyMutationOptions = Apollo.BaseMutationOptions<CreateClientCompanyMutation, CreateClientCompanyMutationVariables>;
export const CreateLabClientNoteDocument = gql`
    mutation createLabClientNote($input: CreateLabClientNoteInput!) {
  createLabClientNote(input: $input) {
    note {
      ...LabClientNoteFields
    }
  }
}
    ${LabClientNoteFieldsFragmentDoc}`;
export type CreateLabClientNoteMutationFn = Apollo.MutationFunction<CreateLabClientNoteMutation, CreateLabClientNoteMutationVariables>;

/**
 * __useCreateLabClientNoteMutation__
 *
 * To run a mutation, you first call `useCreateLabClientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabClientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabClientNoteMutation, { data, loading, error }] = useCreateLabClientNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLabClientNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateLabClientNoteMutation, CreateLabClientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLabClientNoteMutation, CreateLabClientNoteMutationVariables>(CreateLabClientNoteDocument, options);
      }
export type CreateLabClientNoteMutationHookResult = ReturnType<typeof useCreateLabClientNoteMutation>;
export type CreateLabClientNoteMutationResult = Apollo.MutationResult<CreateLabClientNoteMutation>;
export type CreateLabClientNoteMutationOptions = Apollo.BaseMutationOptions<CreateLabClientNoteMutation, CreateLabClientNoteMutationVariables>;
export const UpdateClientCompanyDocument = gql`
    mutation updateClientCompany($input: UpdateClientCompanyInput!) {
  updateClientCompany(input: $input) {
    clientCompany {
      ...ClientCompanyFields
    }
  }
}
    ${ClientCompanyFieldsFragmentDoc}`;
export type UpdateClientCompanyMutationFn = Apollo.MutationFunction<UpdateClientCompanyMutation, UpdateClientCompanyMutationVariables>;

/**
 * __useUpdateClientCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateClientCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientCompanyMutation, { data, loading, error }] = useUpdateClientCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientCompanyMutation, UpdateClientCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientCompanyMutation, UpdateClientCompanyMutationVariables>(UpdateClientCompanyDocument, options);
      }
export type UpdateClientCompanyMutationHookResult = ReturnType<typeof useUpdateClientCompanyMutation>;
export type UpdateClientCompanyMutationResult = Apollo.MutationResult<UpdateClientCompanyMutation>;
export type UpdateClientCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateClientCompanyMutation, UpdateClientCompanyMutationVariables>;
export const UpdateClientCompanyInternalDocument = gql`
    mutation updateClientCompanyInternal($input: UpdateClientCompanyInternalInput!) {
  updateClientCompanyInternal(input: $input) {
    clientCompany {
      ...ClientCompanyInternal
    }
  }
}
    ${ClientCompanyInternalFragmentDoc}`;
export type UpdateClientCompanyInternalMutationFn = Apollo.MutationFunction<UpdateClientCompanyInternalMutation, UpdateClientCompanyInternalMutationVariables>;

/**
 * __useUpdateClientCompanyInternalMutation__
 *
 * To run a mutation, you first call `useUpdateClientCompanyInternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientCompanyInternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientCompanyInternalMutation, { data, loading, error }] = useUpdateClientCompanyInternalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientCompanyInternalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientCompanyInternalMutation, UpdateClientCompanyInternalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientCompanyInternalMutation, UpdateClientCompanyInternalMutationVariables>(UpdateClientCompanyInternalDocument, options);
      }
export type UpdateClientCompanyInternalMutationHookResult = ReturnType<typeof useUpdateClientCompanyInternalMutation>;
export type UpdateClientCompanyInternalMutationResult = Apollo.MutationResult<UpdateClientCompanyInternalMutation>;
export type UpdateClientCompanyInternalMutationOptions = Apollo.BaseMutationOptions<UpdateClientCompanyInternalMutation, UpdateClientCompanyInternalMutationVariables>;
export const UpdateClientCompanyPricingDocument = gql`
    mutation updateClientCompanyPricing($input: UpdateClientCompanyPricingInput!) {
  updateClientCompanyPricing(input: $input) {
    clientCompany {
      ...ClientCompanyWithPricing
    }
  }
}
    ${ClientCompanyWithPricingFragmentDoc}`;
export type UpdateClientCompanyPricingMutationFn = Apollo.MutationFunction<UpdateClientCompanyPricingMutation, UpdateClientCompanyPricingMutationVariables>;

/**
 * __useUpdateClientCompanyPricingMutation__
 *
 * To run a mutation, you first call `useUpdateClientCompanyPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientCompanyPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientCompanyPricingMutation, { data, loading, error }] = useUpdateClientCompanyPricingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientCompanyPricingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientCompanyPricingMutation, UpdateClientCompanyPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientCompanyPricingMutation, UpdateClientCompanyPricingMutationVariables>(UpdateClientCompanyPricingDocument, options);
      }
export type UpdateClientCompanyPricingMutationHookResult = ReturnType<typeof useUpdateClientCompanyPricingMutation>;
export type UpdateClientCompanyPricingMutationResult = Apollo.MutationResult<UpdateClientCompanyPricingMutation>;
export type UpdateClientCompanyPricingMutationOptions = Apollo.BaseMutationOptions<UpdateClientCompanyPricingMutation, UpdateClientCompanyPricingMutationVariables>;
export const SendPasswordResetEmailDocument = gql`
    mutation sendPasswordResetEmail($email: String!) {
  sendPasswordResetEmail(email: $email) {
    ... on SendPasswordResetEmailSuccess {
      success
    }
    ... on Error {
      message
    }
  }
}
    `;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, options);
      }
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;
export const VerifyAddressDocument = gql`
    mutation verifyAddress($input: VerifyAddressInput!) {
  verifyAddress(input: $input) {
    success
    errors {
      code
      field
      message
      suggestion
    }
  }
}
    `;
export type VerifyAddressMutationFn = Apollo.MutationFunction<VerifyAddressMutation, VerifyAddressMutationVariables>;

/**
 * __useVerifyAddressMutation__
 *
 * To run a mutation, you first call `useVerifyAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAddressMutation, { data, loading, error }] = useVerifyAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAddressMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAddressMutation, VerifyAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAddressMutation, VerifyAddressMutationVariables>(VerifyAddressDocument, options);
      }
export type VerifyAddressMutationHookResult = ReturnType<typeof useVerifyAddressMutation>;
export type VerifyAddressMutationResult = Apollo.MutationResult<VerifyAddressMutation>;
export type VerifyAddressMutationOptions = Apollo.BaseMutationOptions<VerifyAddressMutation, VerifyAddressMutationVariables>;
export const PasswordResetDocument = gql`
    mutation passwordReset($token: String!, $newPassword1: String!, $newPassword2: String!) {
  passwordReset(
    token: $token
    newPassword1: $newPassword1
    newPassword2: $newPassword2
  ) {
    ... on PasswordResetSuccess {
      success
    }
    ... on Error {
      message
    }
  }
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      token: // value for 'token'
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, options);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const RegisterUserAndClientCompanyDocument = gql`
    mutation registerUserAndClientCompany($input: RegisterUserAndClientCompanyInput!) {
  registerUserAndClientCompany(input: $input) {
    success
    errors
    token
    refreshToken
  }
}
    `;
export type RegisterUserAndClientCompanyMutationFn = Apollo.MutationFunction<RegisterUserAndClientCompanyMutation, RegisterUserAndClientCompanyMutationVariables>;

/**
 * __useRegisterUserAndClientCompanyMutation__
 *
 * To run a mutation, you first call `useRegisterUserAndClientCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserAndClientCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserAndClientCompanyMutation, { data, loading, error }] = useRegisterUserAndClientCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserAndClientCompanyMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserAndClientCompanyMutation, RegisterUserAndClientCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserAndClientCompanyMutation, RegisterUserAndClientCompanyMutationVariables>(RegisterUserAndClientCompanyDocument, options);
      }
export type RegisterUserAndClientCompanyMutationHookResult = ReturnType<typeof useRegisterUserAndClientCompanyMutation>;
export type RegisterUserAndClientCompanyMutationResult = Apollo.MutationResult<RegisterUserAndClientCompanyMutation>;
export type RegisterUserAndClientCompanyMutationOptions = Apollo.BaseMutationOptions<RegisterUserAndClientCompanyMutation, RegisterUserAndClientCompanyMutationVariables>;
export const TokenAuthDocument = gql`
    mutation tokenAuth($email: String!, $password: String!) {
  tokenAuth(email_Iexact: $email, password: $password) {
    ... on TokenAuthSuccess {
      token
      refreshToken
      user {
        ...ProfileFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${ProfileFieldsFragmentDoc}`;
export type TokenAuthMutationFn = Apollo.MutationFunction<TokenAuthMutation, TokenAuthMutationVariables>;

/**
 * __useTokenAuthMutation__
 *
 * To run a mutation, you first call `useTokenAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenAuthMutation, { data, loading, error }] = useTokenAuthMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useTokenAuthMutation(baseOptions?: Apollo.MutationHookOptions<TokenAuthMutation, TokenAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TokenAuthMutation, TokenAuthMutationVariables>(TokenAuthDocument, options);
      }
export type TokenAuthMutationHookResult = ReturnType<typeof useTokenAuthMutation>;
export type TokenAuthMutationResult = Apollo.MutationResult<TokenAuthMutation>;
export type TokenAuthMutationOptions = Apollo.BaseMutationOptions<TokenAuthMutation, TokenAuthMutationVariables>;
export const UpdateTrackingColumnDocument = gql`
    mutation updateTrackingColumn($name: String!, $enabled: Boolean!) {
  updateTrackingColumn(name: $name, enabled: $enabled) {
    user {
      trackingColumnsEnabled
      trackingColumnsAvailable
    }
  }
}
    `;
export type UpdateTrackingColumnMutationFn = Apollo.MutationFunction<UpdateTrackingColumnMutation, UpdateTrackingColumnMutationVariables>;

/**
 * __useUpdateTrackingColumnMutation__
 *
 * To run a mutation, you first call `useUpdateTrackingColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackingColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackingColumnMutation, { data, loading, error }] = useUpdateTrackingColumnMutation({
 *   variables: {
 *      name: // value for 'name'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateTrackingColumnMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackingColumnMutation, UpdateTrackingColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackingColumnMutation, UpdateTrackingColumnMutationVariables>(UpdateTrackingColumnDocument, options);
      }
export type UpdateTrackingColumnMutationHookResult = ReturnType<typeof useUpdateTrackingColumnMutation>;
export type UpdateTrackingColumnMutationResult = Apollo.MutationResult<UpdateTrackingColumnMutation>;
export type UpdateTrackingColumnMutationOptions = Apollo.BaseMutationOptions<UpdateTrackingColumnMutation, UpdateTrackingColumnMutationVariables>;
export const UpdateNotificationEnabledDocument = gql`
    mutation updateNotificationEnabled($name: String!, $enabled: Boolean!) {
  updateNotificationEnabled(name: $name, enabled: $enabled) {
    user {
      notificationsEnabled
    }
  }
}
    `;
export type UpdateNotificationEnabledMutationFn = Apollo.MutationFunction<UpdateNotificationEnabledMutation, UpdateNotificationEnabledMutationVariables>;

/**
 * __useUpdateNotificationEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationEnabledMutation, { data, loading, error }] = useUpdateNotificationEnabledMutation({
 *   variables: {
 *      name: // value for 'name'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateNotificationEnabledMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationEnabledMutation, UpdateNotificationEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationEnabledMutation, UpdateNotificationEnabledMutationVariables>(UpdateNotificationEnabledDocument, options);
      }
export type UpdateNotificationEnabledMutationHookResult = ReturnType<typeof useUpdateNotificationEnabledMutation>;
export type UpdateNotificationEnabledMutationResult = Apollo.MutationResult<UpdateNotificationEnabledMutation>;
export type UpdateNotificationEnabledMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationEnabledMutation, UpdateNotificationEnabledMutationVariables>;
export const CreateHealthProfileDocument = gql`
    mutation createHealthProfile($input: CreateHealthProfileInput!) {
  createHealthProfile(input: $input) {
    healthProfile {
      ...HealthProfile
    }
  }
}
    ${HealthProfileFragmentDoc}`;
export type CreateHealthProfileMutationFn = Apollo.MutationFunction<CreateHealthProfileMutation, CreateHealthProfileMutationVariables>;

/**
 * __useCreateHealthProfileMutation__
 *
 * To run a mutation, you first call `useCreateHealthProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHealthProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHealthProfileMutation, { data, loading, error }] = useCreateHealthProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHealthProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateHealthProfileMutation, CreateHealthProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHealthProfileMutation, CreateHealthProfileMutationVariables>(CreateHealthProfileDocument, options);
      }
export type CreateHealthProfileMutationHookResult = ReturnType<typeof useCreateHealthProfileMutation>;
export type CreateHealthProfileMutationResult = Apollo.MutationResult<CreateHealthProfileMutation>;
export type CreateHealthProfileMutationOptions = Apollo.BaseMutationOptions<CreateHealthProfileMutation, CreateHealthProfileMutationVariables>;
export const UpdateHealthProfileDocument = gql`
    mutation updateHealthProfile($input: UpdateHealthProfileInput!) {
  updateHealthProfile(input: $input) {
    healthProfile {
      ...HealthProfile
    }
  }
}
    ${HealthProfileFragmentDoc}`;
export type UpdateHealthProfileMutationFn = Apollo.MutationFunction<UpdateHealthProfileMutation, UpdateHealthProfileMutationVariables>;

/**
 * __useUpdateHealthProfileMutation__
 *
 * To run a mutation, you first call `useUpdateHealthProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHealthProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHealthProfileMutation, { data, loading, error }] = useUpdateHealthProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHealthProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHealthProfileMutation, UpdateHealthProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHealthProfileMutation, UpdateHealthProfileMutationVariables>(UpdateHealthProfileDocument, options);
      }
export type UpdateHealthProfileMutationHookResult = ReturnType<typeof useUpdateHealthProfileMutation>;
export type UpdateHealthProfileMutationResult = Apollo.MutationResult<UpdateHealthProfileMutation>;
export type UpdateHealthProfileMutationOptions = Apollo.BaseMutationOptions<UpdateHealthProfileMutation, UpdateHealthProfileMutationVariables>;
export const ArchiveHealthProfileDocument = gql`
    mutation archiveHealthProfile($id: ID!) {
  archiveHealthProfile(id: $id) {
    healthProfile {
      ...HealthProfile
    }
  }
}
    ${HealthProfileFragmentDoc}`;
export type ArchiveHealthProfileMutationFn = Apollo.MutationFunction<ArchiveHealthProfileMutation, ArchiveHealthProfileMutationVariables>;

/**
 * __useArchiveHealthProfileMutation__
 *
 * To run a mutation, you first call `useArchiveHealthProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveHealthProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveHealthProfileMutation, { data, loading, error }] = useArchiveHealthProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveHealthProfileMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveHealthProfileMutation, ArchiveHealthProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveHealthProfileMutation, ArchiveHealthProfileMutationVariables>(ArchiveHealthProfileDocument, options);
      }
export type ArchiveHealthProfileMutationHookResult = ReturnType<typeof useArchiveHealthProfileMutation>;
export type ArchiveHealthProfileMutationResult = Apollo.MutationResult<ArchiveHealthProfileMutation>;
export type ArchiveHealthProfileMutationOptions = Apollo.BaseMutationOptions<ArchiveHealthProfileMutation, ArchiveHealthProfileMutationVariables>;
export const UnarchiveHealthProfileDocument = gql`
    mutation unarchiveHealthProfile($id: ID!) {
  unarchiveHealthProfile(id: $id) {
    healthProfile {
      ...HealthProfile
    }
  }
}
    ${HealthProfileFragmentDoc}`;
export type UnarchiveHealthProfileMutationFn = Apollo.MutationFunction<UnarchiveHealthProfileMutation, UnarchiveHealthProfileMutationVariables>;

/**
 * __useUnarchiveHealthProfileMutation__
 *
 * To run a mutation, you first call `useUnarchiveHealthProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveHealthProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveHealthProfileMutation, { data, loading, error }] = useUnarchiveHealthProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveHealthProfileMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveHealthProfileMutation, UnarchiveHealthProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveHealthProfileMutation, UnarchiveHealthProfileMutationVariables>(UnarchiveHealthProfileDocument, options);
      }
export type UnarchiveHealthProfileMutationHookResult = ReturnType<typeof useUnarchiveHealthProfileMutation>;
export type UnarchiveHealthProfileMutationResult = Apollo.MutationResult<UnarchiveHealthProfileMutation>;
export type UnarchiveHealthProfileMutationOptions = Apollo.BaseMutationOptions<UnarchiveHealthProfileMutation, UnarchiveHealthProfileMutationVariables>;